//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum eActionState {
	NotSet = 0,
	Inserted = 1,
	Changed = 2,
	Deleted = 3,
	Activated = 4,
	Deactivated = 5
}
export enum eContactCardType {
	Client = 0,
	Buyer = 1,
	Agent = 2,
	Venue = 3,
	Location = 4
}
export enum eContactSection {
	Client = 0,
	Deals = 1,
	Itinerary = 2,
	TvPackage = 3
}
export enum eColumnType {
	None = 0,
	Checkbox = 1,
	PlainText = 2,
	Hyperlink = 3,
	Address = 4,
	List = 5,
	Email = 6,
	Date = 7,
	Currency = 8,
	FaIcon = 9,
	Time = 10,
	Dropdown = 11,
	HyperlinkList = 12,
	CurrencyAmount = 13,
	DateTime = 14,
	ImageColumn = 15
}
export enum eDateFormat {
	Date = 1,
	Time = 2,
	DaysAgo = 3,
	DatePlusDaysAgo = 4
}
export enum eEnvironment {
	NotSet = 0,
	Local = 1,
	LocalDev = 2,
	LocalQA = 3,
	Development = 4,
	QA = 5,
	Staging = 6,
	Live = 7,
	Migration = 8
}
export enum eSearchContactType {
	Client = 1,
	Buyer = 2,
	User = 3,
	Contact = 4,
	Venue = 5,
	Agent = 6,
	ContactAgent = 7,
	Location = 8,
	AdminAgent = 9,
	TvPckgAgentUser = 10,
	TvPckgNetworkBuyer = 11,
	TvPckgStudioProdBuyer = 12,
	ContactBrand = 13,
	Employee = 14,
	TvPckgClientTalent = 15
}
export enum eSortDir {
	NotSet = 0,
	ASC = 1,
	DESC = -1
}
export enum eDefaultPane {
	Settings = 1
}
export enum eStatusCode {
	Active = 1,
	Inactive = 2,
	Deleted = 3
}
export enum eSystemFunction {
	SystemAdmin = 1,
	SuperUser = 2,
	ManageProperty = 3,
	ReadDealsExFI = 4,
	ReadDeals = 5,
	ModifyDeals = 6,
	InterfaceToLegalOnline = 7,
	InterfaceToSAP = 8,
	RevenueRecognition = 9,
	DealAdmin = 10,
	AccessToProjects = 11
}
export enum eFilterFieldType {
	Empty = 0,
	Container = 1,
	Search = 2,
	CheckBox = 3,
	SingleSelect = 4,
	MultiSelect = 5,
	PickerContact = 6,
	PickerEnum = 7,
	Date = 8,
	DateBetween = 9,
	NgMultiSelect = 10,
	SingleSelectSearch = 11,
	NgMultiSelectSearch = 12
}
export enum eModules {
	Clients = 1,
	Bookings = 2,
	Buyers = 3,
	Contacts = 4,
	Itinerary = 5,
	PhoneLog = 6,
	Deals = 7,
	Users = 8,
	Packages = 9,
	Tv10Bookings = 10
}
export enum eItineraryClientListTypes {
	All = 1,
	Rosters = 2,
	Private = 3
}
export enum eExternalCalendarImportType {
	Imported = 1,
	Url = 2
}
export enum eExternalCalendarTypes {
	Public = 1,
	MyList = 2
}
export enum eItineraryView {
	NotSet = 0,
	Monthly = 1,
	Quarterly = 2
}
export enum eClientGenreLiterary {
	Not_Set = 0,
	Absurdistsurrealwhimsical = 1,
	Action = 2,
	Adventure = 3,
	Comedy = 4,
	Crime = 5,
	Drama = 6,
	Fantasy = 7,
	Historical = 8,
	Historical_fiction = 9,
	Horror = 10,
	Magical_realism = 11,
	Mystery = 12,
	Paranoid = 13,
	Philosophical = 14,
	Political = 15,
	Romance = 16,
	Saga = 17,
	Satire = 18,
	Science_fiction = 19,
	Slice_of_Life = 20,
	DataError = -99
}
export enum eClientGenreMusic {
	Not_Set = 0,
	Classical = 1,
	Folk = 2,
	Country_music = 3,
	Gospel_music = 4,
	DataError = -99
}
export enum eClientGenreFilmAndTv {
	Not_Set = 0,
	Liveaction_scriptd = 1,
	Action = 3,
	Adventure = 4,
	Comedy = 5,
	Romance = 6,
	Western = 7,
	TV_Others = 8,
	DataError = -99
}
export enum eTVPType {
	Package = 0,
	Booking = 1,
	PreCrm = 2
}
export enum eFrequencyType {
	Note_Set = 0,
	Weekly = 1,
	Bi_Weekly = 2,
	Monthly = 3,
	Bi_Monthly = 4,
	Quarterly = 5,
	Semi_Anually = 6,
	Anually = 7
}
export enum eImageSize {
	NotSet = 0,
	XS = 1,
	SM = 2,
	MD = 4,
	LG = 8,
	OR = 16,
	All = 31
}
export enum eUserType {
	Not_Set = 0,
	Coordinator = 1,
	Agent = 2,
	Assistant = 3,
	Trainee = 4,
	ServiceAccount = 5,
	Other = 7,
	DataError = -99
}
export enum eUserRole {
	Not_Set = 0,
	Global_Administrator = 1,
	HUBTMS_System_Administrator = 2,
	HUBTMS_Bank_Account_Manager = 3,
	HUBTMS_TPC = 4,
	HUBPackages_Packages_Admin = 5,
	HUBPackages_Packages_ReadOnly = 6,
	HUBPackages_Financial_Admin = 7,
	HUBPackages_TVSManager = 8,
	HUBPackages_TVSFinance = 9,
	HUBPackages_TVSIntern = 10,
	HUBPackages_TVNSManager = 11,
	HUBPackages_TVNSFinance = 12,
	HUBPackages_TVNSIntern = 13,
	HUBPackages_DIGManager = 14,
	HUBPackages_DIGFinance = 15,
	HUBPackages_DIGIntern = 16
}
export enum eUserPermissionLevel {
	Not_Set = 0,
	Read = 1,
	Write = 2,
	Admin = 3
}
export enum eSystemModule {
	Not_Set = 0,
	HUBTMS_Scans = 1,
	HUBTMS_Banks = 2,
	HUBTMS_Bank_Accounts = 3,
	HUBTMS_Receipts = 4,
	HUBTMS_Settlements = 5,
	HUBTMS_System_Configuration = 6,
	HUBContacts_Users = 7,
	HUBContacts_Clients = 8,
	HUBContacts_Contacts = 9,
	HUBContacts_Buyers = 10,
	HUBContacts_Industries = 11,
	HUBContacts_Venues = 12,
	HUBContacts_Leads = 13,
	HUBTv10Percent_Tv10Percent = 14,
	HUBTvPackages_Admin = 15,
	HUBTvPackages_BeBookings = 16,
	HUBTvPackages_Correspondence = 17,
	HUBTvPackages_TvPackages = 18,
	HUBTvPackages_UfBookings = 19,
	HUBDeal_Deal = 20,
	HUBItinerary_Itinerary = 21
}
export enum eBuyerAttachmentType {
	Not_Set = 0,
	Offer = 101,
	Other = 102,
	Contract_as_issued = 103,
	Contract_as_received_from_Buyer = 104,
	Contract_as_sent_to_Artist = 105,
	Fullyexecuted_Contract_as_sent_to_Buyer = 106,
	Buyerissued_Contract_as_Received = 107,
	Letter_Agreement = 108,
	Email = 109,
	Client_Information_Form = 110,
	ACH_Form = 111,
	Fee_Authorizations = 112,
	Check_Authorization = 113,
	Check_Endorsement = 114,
	W4 = 116,
	W9 = 117,
	_590 = 118,
	I9 = 119,
	Passport = 120,
	Social_Security = 121,
	Drivers_License = 122,
	Birth_Certificate = 123,
	Other_Papers = 124,
	Photo = 126,
	Video = 127,
	Other_Speakers = 128,
	Headshot_Unapproved = 129,
	Movie_Clip = 130,
	Other_Asset = 131,
	Video_Gallery = 133,
	Document = 135,
	Headshot_Approved = 136,
	Credits = 137,
	Resume = 138,
	Bio = 139,
	Agency_Agreements = 140,
	Articles_of_Incorporation = 141,
	Confirmation_of_Rep_Letter = 142,
	Full_Bio = 143,
	BKS_TV_type_1 = 144,
	BKS_MP_type = 145,
	BKS_CO_type = 146,
	BKS_TV_type_2 = 147,
	Script_PDF = 148,
	Script = 149,
	Project_Role_Side = 150,
	W8 = 151,
	Visa_Document = 152,
	Client_Packet = 153,
	Contract = 154,
	Talent_Packet = 155,
	Minor_Packet = 156,
	Other_Documents = 157
}
export enum eBuyerCategory {
	Not_Set = 0,
	Other = 1,
	Accessories_Jewelry_Watches = 2,
	Apparel = 3,
	Appliances = 4,
	Automobiles_Trucks = 5,
	Aviation_Aerospace = 6,
	Beauty_Products = 7,
	Beverages_Soft_Drinks = 8,
	Cleaning_Agents = 9,
	Computers_Office_Equipment_Supplies_Services = 10,
	Department_Stores = 11,
	Electronics_Devices_Retailers = 12,
	Financial_Services = 13,
	Food_Manufactures = 14,
	Food_Retailers = 15,
	Furniture = 16,
	Games_Toys = 17,
	Gasoline_Lubricants = 18,
	Heating_Air_Conditioning = 19,
	Hotels_Resorts = 20,
	Housewares = 21,
	Insurance = 22,
	Interactive = 23,
	Internet = 24,
	Lighting = 25,
	Optical_Photo = 26,
	Paints_Varnishes_Wall_Coverings = 27,
	Paper_Packaging_Containers = 28,
	Pet_Food = 29,
	Pharmaceuticals_Health_Care_Products = 30,
	Public_Utilities = 31,
	Sporting_Goods_Stores_Equipment = 32,
	TelecommunicationsWireless_Communications = 33,
	Tires_Tubes_Rubber_Molded_Products_Plastics = 34,
	Wines_Liquors = 35,
	DataError = -99
}
export enum eBuyerCompanyType {
	Not_Set = 0,
	Business_Manager = 1,
	Label = 2,
	Law_Firm = 3,
	Management = 4,
	PR = 5,
	Publisher = 6,
	Production_Company = 7,
	Foreign_Agent = 8,
	Road_Management = 9,
	CoAgency = 10,
	Other = 11,
	DataError = -99
}
export enum eBuyerEmailType {
	Not_Set = 0,
	Personal = 1,
	Office = 2,
	DataError = -99
}
export enum eBuyerMarket {
	Not_Set = 0,
	Adult_Contemporary_Music = 1,
	Contemporary_Music = 2,
	Country_Music = 3,
	Literary_Books_Domestic = 4,
	Merchandising_AND_Licensing = 5,
	Mopic_Literary = 6,
	Mopic = 7,
	Mopic_Production_Companies = 8,
	Mopic_Studios = 9,
	New_Media = 10,
	Newscasters_AND_Sportscasters = 11,
	TV_AND_Radio = 12,
	TV_Literary = 13,
	TV_Packaging = 14,
	Theatre = 15,
	TV_Networks = 16,
	TV_Production_Companies = 17,
	Literary_Books_Foreign = 18,
	TV_Studios = 19,
	Corporate_Contacts = 20,
	Corporate_Licensing = 21,
	Commercial = 23,
	Music_PA = 24,
	Self_Serve = 25,
	WME_Speakers = 26,
	Global = 27,
	TV_Networks_Broadcast = 30,
	TV_Networks_Cable = 31,
	TV_NetworksDigital = 32,
	TV_Packaging_Network = 33,
	TV_Packaging_Studio = 34,
	TV_Packaging_Production_Company = 35,
	DataError = -99
}
export enum eBuyerNoteType {
	Not_Set = 0,
	Public_Comments = 1,
	Executive_Notes = 2,
	Literary_Rights = 3,
	DataError = -99
}
export enum eBuyerNotificationMethod {
	Not_Set = 0,
	Hardcopy = 1,
	Email = 2,
	Both = 3,
	DataError = -99
}
export enum eBuyerPhoneType {
	Not_Set = 0,
	Office = 1,
	Home = 2,
	Mobile = 3,
	DataError = -99
}
export enum eClientAttachmentType {
	Not_Set = 0,
	Offer = 1,
	Other = 2,
	Contract_as_issued = 3,
	Contract_as_received_from_Buyer = 4,
	Contract_as_sent_to_Artist = 5,
	Fullyexecuted_Contract_as_sent_to_Buyer = 6,
	Buyerissued_Contract_as_Received = 7,
	Letter_Agreement = 8,
	Email = 9,
	Client_Information_Form = 10,
	ACH_Form = 11,
	Fee_Authorizations = 12,
	Check_Authorization = 13,
	Check_Endorsement = 14,
	W4 = 16,
	W9 = 17,
	_590 = 18,
	I9 = 19,
	Passport = 20,
	Social_Security = 21,
	Drivers_License = 22,
	Birth_Certificate = 23,
	Other_Papers = 24,
	Photo = 26,
	Video = 27,
	Other_Speakers = 28,
	Headshot_Unapproved = 29,
	Movie_Clip = 30,
	Other_Asset = 31,
	Video_Gallery = 33,
	Document = 35,
	Headshot_Approved = 36,
	Credits = 37,
	Resume = 38,
	Bio = 39,
	Agency_Agreements = 40,
	Articles_of_Incorporation = 41,
	Confirmation_of_Rep_Letter = 42,
	Full_Bio = 43,
	BKS_TV_type_1 = 44,
	BKS_MP_type = 45,
	BKS_CO_type = 46,
	BKS_TV_type_2 = 47,
	Script_PDF = 48,
	Script = 49,
	Project_Role_Side = 50,
	W8 = 51,
	Visa_Document = 52,
	Client_Packet = 53,
	Contract = 54,
	Talent_Packet = 55,
	Minor_Packet = 56,
	Other_Documents = 57
}
export enum eClientCreditType {
	Not_Set = 0,
	Awards_AND_Honors = 1,
	Comics_AND_Graphic_Novels = 2,
	Commercial = 3,
	Education = 4,
	Other = 5,
	Film = 6,
	Film_Documentary = 7,
	Film_Shorts = 8,
	Music_Videos = 9,
	Other_Experience = 10,
	Publishing_Books = 11,
	Television_Longform = 12,
	Television_Miniseries = 13,
	Television_NonScripted = 14,
	Television_NonScripted_International = 15,
	Television_Pilots = 16,
	Television_Series = 17,
	Television_Specials = 18,
	Television_Variety = 19,
	Theatre = 20,
	Video_Game = 21,
	Digital = 22,
	Television = 31,
	Director = 32,
	Theater = 33,
	Motion_Picture = 34,
	DataError = -99
}
export enum eClientDepartment {
	Not_Set = 0,
	All = 1,
	CO = 2,
	GN = 3,
	LND = 4,
	LP = 5,
	LT = 6,
	MP = 7,
	PA = 8,
	SV = 9,
	TV = 10,
	TVP = 11,
	TVS = 12,
	DataError = -99
}
export enum eClientEmailType {
	Not_Set = 0,
	Personal = 1,
	Office = 2,
	DataError = -99
}
export enum eClientNotifyLevel {
	Not_Set = 0,
	All = 1,
	None = 2,
	Confirm = 3,
	NA = 4,
	DataError = -99
}
export enum eClientParticipantType {
	Not_Set = 0,
	Business_Manager = 1,
	Label = 2,
	Law_Firm = 3,
	Management = 4,
	PR = 5,
	Publisher = 6,
	Production_Company = 7,
	Foreign_Agent = 8,
	Road_Management = 9,
	CoAgency = 10,
	Other = 11,
	DataError = -99
}
export enum eClientPaymentMethod {
	Not_Set = 0,
	Cash = 1,
	Check = 2,
	Bank_Deposit = 3,
	Wire = 4,
	DataError = -99
}
export enum eClientPhoneType {
	Not_Set = 0,
	Home = 1,
	Mobile = 2,
	Office = 3,
	DataError = -99
}
export enum eClientStatus {
	Not_Set = 0,
	Client_ALL = 1,
	Client_LTD = 2,
	Hip_Pocket = 3,
	Deal_Only = 4,
	Former_Client = 5,
	Package_Show = 6,
	DataError = -99
}
export enum eClientType {
	Not_Set = 0,
	Individual = 1,
	Company = 2,
	TeamGroup = 3,
	DataError = -99
}
export enum eContactAgeRange {
	Not_Set = 0,
	Under_20 = 1,
	_20_30 = 2,
	_31_40 = 3,
	_41_50 = 4,
	Over_50 = 5,
	DataError = -99
}
export enum eContactAttachmentType {
	Not_Set = 0,
	Offer = 201,
	Other = 202,
	Contract_as_issued = 203,
	Contract_as_received_from_Buyer = 204,
	Contract_as_sent_to_Artist = 205,
	Fullyexecuted_Contract_as_sent_to_Buyer = 206,
	Buyerissued_Contract_as_Received = 207,
	Letter_Agreement = 208,
	Email = 209,
	Client_Information_Form = 210,
	ACH_Form = 211,
	Fee_Authorizations = 212,
	Check_Authorization = 213,
	Check_Endorsement = 214,
	W4 = 216,
	W9 = 217,
	_590 = 218,
	I9 = 219,
	Passport = 220,
	Social_Security = 221,
	Drivers_License = 222,
	Birth_Certificate = 223,
	Other_Papers = 224,
	Photo = 226,
	Video = 227,
	Other_Speakers = 228,
	Headshot_Unapproved = 229,
	Movie_Clip = 230,
	Other_Asset = 231,
	Video_Gallery = 233,
	Document = 235,
	Headshot_Approved = 236,
	Credits = 237,
	Resume = 238,
	Bio = 239,
	Agency_Agreements = 240,
	Articles_of_Incorporation = 241,
	Confirmation_of_Rep_Letter = 242,
	Full_Bio = 243,
	BKS_TV_type_1 = 244,
	BKS_MP_type = 245,
	BKS_CO_type = 246,
	BKS_TV_type_2 = 247,
	Script_PDF = 248,
	Script = 249,
	Project_Role_Side = 250,
	W8 = 251,
	Visa_Document = 252,
	Client_Packet = 253,
	Contract = 254,
	Talent_Packet = 255,
	Minor_Packet = 256,
	Other_Documents = 257
}
export enum eContactCategory {
	Not_Set = 0,
	Generic = 4,
	Talent = 5,
	SubAgent = 6,
	Outside_Agent = 7,
	Casting_Agent = 8,
	Industry = 10,
	Assistant = 11,
	DataError = -99
}
export enum eContactEmailType {
	Not_Set = 0,
	Personal = 1,
	Office = 2,
	DataError = -99
}
export enum eContactNoteType {
	Not_Set = 0,
	Public_Comments = 1,
	Executive_Notes = 2,
	Literary_Rights = 3,
	DataError = -99
}
export enum eContactPhoneType {
	Not_Set = 0,
	Office = 1,
	Home = 2,
	Mobile = 3,
	DataError = -99
}
export enum eContactStatusFilter {
	Not_Set = 0,
	ActiveClient = 1,
	ConfidentialDirectory = 2,
	Archived = 3,
	DataError = -99
}
export enum eContactType {
	Not_Set = 0,
	Individual = 1,
	Company = 2,
	TeamGroup = 3,
	DataError = -99
}
export enum eContactVenueLocation {
	Not_Set = 0,
	USA = 1,
	Worldwide = 2,
	DataError = -99
}
export enum eContactVenueType {
	Not_Set = 0,
	Theater = 1,
	Amphitheater = 2,
	Casino = 3,
	Hall = 4,
	Stadium = 5,
	Fair = 6,
	Festival = 7,
	DataError = -99
}
export enum eContactWorkArea {
	Not_Set = 0,
	Motion_Picture = 1,
	Commercial = 2,
	Speaking_Engagements = 3,
	Literary_Books = 4,
	MusicPersonal_Appearance = 5,
	Television = 6,
	Theatre = 7,
	Sports = 8,
	Marketing = 9,
	All_Areas = 10,
	Broadcast = 11,
	VoiceOver = 12,
	Owner_of_Rights = 13,
	Branded_Lifestyle = 14,
	Television_Scripted = 15,
	Production = 16,
	Television_Non_Scripted = 17,
	WME_Touring = 18,
	DataError = -99
}
export enum eContactWorkType {
	Not_Set = 0,
	Actor = 1,
	Singer = 4,
	Comedian = 6,
	Musician = 8,
	Athlete = 11,
	SpeakerLecturer = 12,
	Newscaster = 13,
	Sportscaster = 17,
	Writer = 18,
	Director = 20,
	Producer = 22,
	Costume_Designer = 29,
	Production_Designer = 32,
	Production_Company = 36,
	Host = 47,
	Editor = 49,
	Line_Producer = 68,
	Talent = 99,
	Voice_Over = 100,
	Chef = 101,
	Stylist = 102,
	Estate = 103,
	Choreographer = 104,
	Composer = 105,
	Lyricist = 106,
	Director_of_Photography = 107,
	VFX_Supervisor = 108,
	_2nd_Unit_Director = 109,
	Financier = 110,
	Website = 111,
	Game_Developer = 112,
	Author = 113,
	VFX_Company = 114,
	Can_Sing = 115,
	Can_Sing_Trained = 116,
	Assistant_Director = 118,
	Episodic_Director = 119,
	Pilot_Director = 120,
	Showrunner = 125,
	Developer = 129,
	DataError = -99
}
export enum eBusinessUnit {
	Not_Set = 0,
	WME = 1,
	IMG = 2,
	Endeavor = 3,
	DataError = -99
}
export enum eCitizenship {
	Not_Set = 0,
	Afghanistan = 1,
	Aland_Islands = 2,
	Albania = 3,
	Algeria = 4,
	American_Samoa = 5,
	Andorra = 6,
	Angola = 7,
	Anguilla = 8,
	Antarctica = 9,
	Antigua_and_Barbuda = 10,
	Argentina = 11,
	Armenia = 12,
	Aruba = 13,
	Australia = 14,
	Austria = 15,
	Azerbaijan = 16,
	Bahamas = 17,
	Bahrain = 18,
	Bangladesh = 19,
	Barbados = 20,
	Belarus = 21,
	Belgium = 22,
	Belize = 23,
	Benin = 24,
	Bermuda = 25,
	Bhutan = 26,
	Bolivia = 27,
	Bonaire_Sint_Eustatius_and_Saba = 28,
	Bosnia_and_Herzegovina = 29,
	Botswana = 30,
	Bouvet_Island = 31,
	Brazil = 32,
	British_Indian_Ocean_Territory = 33,
	Brunei_Darussalam = 34,
	Bulgaria = 35,
	Burkina_Faso = 36,
	Burundi = 37,
	Cambodia = 38,
	Cameroon = 39,
	Canada = 40,
	Cape_Verde = 41,
	Cayman_Islands = 42,
	Central_African_Republic = 43,
	Chad = 44,
	Chile = 45,
	China = 46,
	Christmas_Island = 47,
	Cocos_Keeling_Islands = 48,
	Colombia = 49,
	Comoros = 50,
	Congo = 51,
	Congo_Democratic_Republic_of_the = 52,
	Cook_Islands = 53,
	Costa_Rica = 54,
	Cote_dIvoire = 55,
	Croatia = 56,
	Cuba = 57,
	Curacao = 58,
	Cyprus = 59,
	Czechia = 60,
	Denmark = 61,
	Djibouti = 62,
	Dominica = 63,
	Dominican_Republic = 64,
	Ecuador = 65,
	Egypt = 66,
	El_Salvador = 67,
	Equatorial_Guinea = 68,
	Eritrea = 69,
	Estonia = 70,
	Ethiopia = 71,
	Falkland_Islands_Malvinas = 72,
	Faroe_Islands = 73,
	Fiji = 74,
	Finland = 75,
	France = 76,
	French_Guiana = 77,
	French_Polynesia = 78,
	French_Southern_Territories = 79,
	Gabon = 80,
	Gambia = 81,
	Georgia = 82,
	Germany = 83,
	Ghana = 84,
	Gibraltar = 85,
	Greece = 86,
	Greenland = 87,
	Grenada = 88,
	Guadeloupe = 89,
	Guam = 90,
	Guatemala = 91,
	Guernsey = 92,
	Guinea = 93,
	GuineaBissau = 94,
	Guyana = 95,
	Haiti = 96,
	Heard_Island_and_Mcdonald_Islands = 97,
	Holy_See_Vatican_City_State = 98,
	Honduras = 99,
	Hong_Kong = 100,
	Hungary = 101,
	Iceland = 102,
	India = 103,
	Indonesia = 104,
	Iran_Islamic_Republic_of = 105,
	Iraq = 106,
	Ireland = 107,
	Israel = 108,
	Italy = 109,
	Jamaica = 110,
	Japan = 111,
	Jersey = 112,
	Jordan = 113,
	Kazakhstan = 114,
	Kenya = 115,
	Kiribati = 116,
	Korea_Democratic_Peoples_Republic_of = 117,
	Korea_Republic_of = 118,
	Kuwait = 119,
	Kyrgyzstan = 120,
	Lao_Peoples_Democratic_Republic = 121,
	Latvia = 122,
	Lebanon = 123,
	Lesotho = 124,
	Liberia = 125,
	Libya = 126,
	Liechtenstein = 127,
	Lithuania = 128,
	Luxembourg = 129,
	Macao = 130,
	Macedonia_the_former_Yugoslav_Republic_of = 131,
	Madagascar = 132,
	Malawi = 133,
	Malaysia = 134,
	Maldives = 135,
	Mali = 136,
	Malta = 137,
	Marshall_Islands = 138,
	Martinique = 139,
	Mauritania = 140,
	Mauritius = 141,
	Mayotte = 142,
	Mexico = 143,
	Micronesia_Federated_States_of = 144,
	Moldova_Republic_of = 145,
	Monaco = 146,
	Mongolia = 147,
	Montenegro = 148,
	Montserrat = 149,
	Morocco = 150,
	Mozambique = 151,
	Myanmar = 152,
	Namibia = 153,
	Nauru = 154,
	Nepal = 155,
	Netherlands = 156,
	New_Caledonia = 157,
	New_Zealand = 158,
	Nicaragua = 159,
	Niger = 160,
	Nigeria = 161,
	Niue = 162,
	Norfolk_Island = 163,
	Northern_Mariana_Islands = 164,
	Norway = 165,
	Oman = 166,
	Pakistan = 167,
	Palau = 168,
	Palestine_State_of = 169,
	Panama = 170,
	Papua_New_Guinea = 171,
	Paraguay = 172,
	Peru = 173,
	Philippines = 174,
	Pitcairn = 175,
	Poland = 176,
	Portugal = 177,
	Puerto_Rico = 178,
	Qatar = 179,
	Reunion = 180,
	Romania = 181,
	Russian_Federation = 182,
	Rwanda = 183,
	Saint_Barthelemy = 184,
	Saint_Helena_Ascension_and_Tristan_da_Cunha = 185,
	Saint_Kitts_and_Nevis = 186,
	Saint_Lucia = 187,
	Saint_Martin_French_part = 188,
	Saint_Pierre_and_Miquelon = 189,
	Saint_Vincent_and_the_Grenadines = 190,
	Samoa = 191,
	San_Marino = 192,
	Sao_Tome_and_Principe = 193,
	Saudi_Arabia = 194,
	Senegal = 195,
	Serbia = 196,
	Seychelles = 197,
	Sierra_Leone = 198,
	Singapore = 199,
	Sint_Maarten_Dutch_part = 200,
	Slovakia = 201,
	Slovenia = 202,
	Solomon_Islands = 203,
	Somalia = 204,
	South_Africa = 205,
	South_Georgia_and_the_South_Sandwich_Islands = 206,
	South_Sudan = 207,
	Spain = 208,
	Sri_Lanka = 209,
	Sudan = 210,
	Suriname = 211,
	Svalbard_and_Jan_Mayen = 212,
	Swaziland = 213,
	Sweden = 214,
	Switzerland = 215,
	Syrian_Arab_Republic = 216,
	Taiwan_Province_of_China = 217,
	Tajikistan = 218,
	Tanzania_United_Republic_of = 219,
	Thailand = 220,
	TimorLeste = 221,
	Togo = 222,
	Tokelau = 223,
	Tonga = 224,
	Trinidad_and_Tobago = 225,
	Tunisia = 226,
	Turkey = 227,
	Turkmenistan = 228,
	Turks_and_Caicos_Islands = 229,
	Tuvalu = 230,
	Uganda = 231,
	Ukraine = 232,
	United_Arab_Emirates = 233,
	United_Kingdom_of_Great_Britain_and_Northern_Ireland = 234,
	United_States_of_America = 235,
	United_States_Minor_Outlying_Islands = 236,
	Uruguay = 237,
	Uzbekistan = 238,
	Vanuatu = 239,
	Venezuela_Bolivarian_Republic_of = 240,
	Viet_Nam = 241,
	Virgin_Islands_British = 242,
	Virgin_Islands_US = 243,
	Wallis_and_Futuna = 244,
	Western_Sahara = 245,
	Yemen = 246,
	Zambia = 247,
	Zimbabwe = 248,
	DataError = -99
}
export enum eCountry {
	Not_Set = 0,
	Afghanistan = 1,
	Aland_Islands = 2,
	Albania = 3,
	Algeria = 4,
	American_Samoa = 5,
	Andorra = 6,
	Angola = 7,
	Anguilla = 8,
	Antarctica = 9,
	Antigua_and_Barbuda = 10,
	Argentina = 11,
	Armenia = 12,
	Aruba = 13,
	Australia = 14,
	Austria = 15,
	Azerbaijan = 16,
	Bahamas = 17,
	Bahrain = 18,
	Bangladesh = 19,
	Barbados = 20,
	Belarus = 21,
	Belgium = 22,
	Belize = 23,
	Benin = 24,
	Bermuda = 25,
	Bhutan = 26,
	Bolivia = 27,
	Bonaire_Sint_Eustatius_and_Saba = 28,
	Bosnia_and_Herzegovina = 29,
	Botswana = 30,
	Bouvet_Island = 31,
	Brazil = 32,
	British_Indian_Ocean_Territory = 33,
	Brunei_Darussalam = 34,
	Bulgaria = 35,
	Burkina_Faso = 36,
	Burundi = 37,
	Cambodia = 38,
	Cameroon = 39,
	Canada = 40,
	Cape_Verde = 41,
	Cayman_Islands = 42,
	Central_African_Republic = 43,
	Chad = 44,
	Chile = 45,
	China = 46,
	Christmas_Island = 47,
	Cocos_Keeling_Islands = 48,
	Colombia = 49,
	Comoros = 50,
	Congo = 51,
	Congo_Democratic_Republic_of_the = 52,
	Cook_Islands = 53,
	Costa_Rica = 54,
	Cote_dIvoire = 55,
	Croatia = 56,
	Cuba = 57,
	Curacao = 58,
	Cyprus = 59,
	Czechia = 60,
	Denmark = 61,
	Djibouti = 62,
	Dominica = 63,
	Dominican_Republic = 64,
	Ecuador = 65,
	Egypt = 66,
	El_Salvador = 67,
	Equatorial_Guinea = 68,
	Eritrea = 69,
	Estonia = 70,
	Ethiopia = 71,
	Falkland_Islands_Malvinas = 72,
	Faroe_Islands = 73,
	Fiji = 74,
	Finland = 75,
	France = 76,
	French_Guiana = 77,
	French_Polynesia = 78,
	French_Southern_Territories = 79,
	Gabon = 80,
	Gambia = 81,
	Georgia = 82,
	Germany = 83,
	Ghana = 84,
	Gibraltar = 85,
	Greece = 86,
	Greenland = 87,
	Grenada = 88,
	Guadeloupe = 89,
	Guam = 90,
	Guatemala = 91,
	Guernsey = 92,
	Guinea = 93,
	GuineaBissau = 94,
	Guyana = 95,
	Haiti = 96,
	Heard_Island_and_Mcdonald_Islands = 97,
	Holy_See_Vatican_City_State = 98,
	Honduras = 99,
	Hong_Kong = 100,
	Hungary = 101,
	Iceland = 102,
	India = 103,
	Indonesia = 104,
	Iran_Islamic_Republic_of = 105,
	Iraq = 106,
	Ireland = 107,
	Israel = 108,
	Italy = 109,
	Jamaica = 110,
	Japan = 111,
	Jersey = 112,
	Jordan = 113,
	Kazakhstan = 114,
	Kenya = 115,
	Kiribati = 116,
	Korea_Democratic_Peoples_Republic_of = 117,
	Korea_Republic_of = 118,
	Kuwait = 119,
	Kyrgyzstan = 120,
	Lao_Peoples_Democratic_Republic = 121,
	Latvia = 122,
	Lebanon = 123,
	Lesotho = 124,
	Liberia = 125,
	Libya = 126,
	Liechtenstein = 127,
	Lithuania = 128,
	Luxembourg = 129,
	Macao = 130,
	Macedonia_the_former_Yugoslav_Republic_of = 131,
	Madagascar = 132,
	Malawi = 133,
	Malaysia = 134,
	Maldives = 135,
	Mali = 136,
	Malta = 137,
	Marshall_Islands = 138,
	Martinique = 139,
	Mauritania = 140,
	Mauritius = 141,
	Mayotte = 142,
	Mexico = 143,
	Micronesia_Federated_States_of = 144,
	Moldova_Republic_of = 145,
	Monaco = 146,
	Mongolia = 147,
	Montenegro = 148,
	Montserrat = 149,
	Morocco = 150,
	Mozambique = 151,
	Myanmar = 152,
	Namibia = 153,
	Nauru = 154,
	Nepal = 155,
	Netherlands = 156,
	New_Caledonia = 157,
	New_Zealand = 158,
	Nicaragua = 159,
	Niger = 160,
	Nigeria = 161,
	Niue = 162,
	Norfolk_Island = 163,
	Northern_Mariana_Islands = 164,
	Norway = 165,
	Oman = 166,
	Pakistan = 167,
	Palau = 168,
	Palestine_State_of = 169,
	Panama = 170,
	Papua_New_Guinea = 171,
	Paraguay = 172,
	Peru = 173,
	Philippines = 174,
	Pitcairn = 175,
	Poland = 176,
	Portugal = 177,
	Puerto_Rico = 178,
	Qatar = 179,
	Reunion = 180,
	Romania = 181,
	Russian_Federation = 182,
	Rwanda = 183,
	Saint_Barthelemy = 184,
	Saint_Helena_Ascension_and_Tristan_da_Cunha = 185,
	Saint_Kitts_and_Nevis = 186,
	Saint_Lucia = 187,
	Saint_Martin_French_part = 188,
	Saint_Pierre_and_Miquelon = 189,
	Saint_Vincent_and_the_Grenadines = 190,
	Samoa = 191,
	San_Marino = 192,
	Sao_Tome_and_Principe = 193,
	Saudi_Arabia = 194,
	Senegal = 195,
	Serbia = 196,
	Seychelles = 197,
	Sierra_Leone = 198,
	Singapore = 199,
	Sint_Maarten_Dutch_part = 200,
	Slovakia = 201,
	Slovenia = 202,
	Solomon_Islands = 203,
	Somalia = 204,
	South_Africa = 205,
	South_Georgia_and_the_South_Sandwich_Islands = 206,
	South_Sudan = 207,
	Spain = 208,
	Sri_Lanka = 209,
	Sudan = 210,
	Suriname = 211,
	Svalbard_and_Jan_Mayen = 212,
	Swaziland = 213,
	Sweden = 214,
	Switzerland = 215,
	Syrian_Arab_Republic = 216,
	Taiwan_Province_of_China = 217,
	Tajikistan = 218,
	Tanzania_United_Republic_of = 219,
	Thailand = 220,
	TimorLeste = 221,
	Togo = 222,
	Tokelau = 223,
	Tonga = 224,
	Trinidad_and_Tobago = 225,
	Tunisia = 226,
	Turkey = 227,
	Turkmenistan = 228,
	Turks_and_Caicos_Islands = 229,
	Tuvalu = 230,
	Uganda = 231,
	Ukraine = 232,
	United_Arab_Emirates = 233,
	United_Kingdom_of_Great_Britain_and_Northern_Ireland = 234,
	United_States_of_America = 235,
	United_States_Minor_Outlying_Islands = 236,
	Uruguay = 237,
	Uzbekistan = 238,
	Vanuatu = 239,
	Venezuela_Bolivarian_Republic_of = 240,
	Viet_Nam = 241,
	Virgin_Islands_British = 242,
	Virgin_Islands_US = 243,
	Wallis_and_Futuna = 244,
	Western_Sahara = 245,
	Yemen = 246,
	Zambia = 247,
	Zimbabwe = 248,
	DataError = -99
}
export enum eCurrency {
	Not_Set = 0,
	USD = 1,
	GBP = 2,
	JPY = 3,
	EUR = 4,
	CAD = 5,
	AUD = 7,
	BRL = 8,
	CNY = 9,
	DKK = 10,
	HKD = 11,
	INR = 12,
	MYR = 13,
	MXN = 14,
	NZD = 15,
	NOK = 16,
	SGD = 17,
	ZAR = 18,
	KRW = 19,
	LKR = 20,
	SEK = 21,
	CHF = 22,
	TWD = 23,
	THB = 24,
	VEB = 25,
	ARS = 26,
	AWG = 27,
	BSD = 28,
	BBD = 29,
	BMD = 30,
	BZD = 31,
	BND = 33,
	KHR = 34,
	KYD = 35,
	CLP = 36,
	COP = 37,
	CRC = 38,
	CUP = 39,
	CYP = 40,
	DOP = 41,
	XCD = 42,
	EGP = 43,
	SVC = 44,
	FKP = 45,
	FJD = 46,
	GIP = 47,
	IRR = 48,
	ILS = 49,
	JMD = 50,
	KPW = 51,
	LAK = 52,
	LBP = 53,
	LRD = 54,
	MTL = 55,
	MUR = 56,
	MNT = 57,
	NAD = 58,
	NPR = 59,
	NGN = 60,
	PKR = 61,
	PEN = 62,
	PHP = 63,
	RUB = 64,
	SAR = 65,
	QAR = 66,
	OMR = 67,
	TRY = 70,
	VND = 72,
	YER = 73,
	ZWD = 74,
	CZK = 75,
	ISK = 76,
	HUF = 77,
	PLN = 78,
	LTL = 79,
	SKK = 80,
	IDR = 81,
	PAB = 82,
	EEK = 83,
	LVL = 84,
	UAH = 85,
	KZT = 86,
	MAD = 87,
	AED = 88,
	TTD = 89,
	SYP = 90,
	HRK = 91,
	RON = 92,
	ROL = 93,
	TND = 94,
	BGL = 95,
	GHS = 96,
	RSD = 97,
	UZS = 98,
	LYD = 99,
	DZD = 101,
	KES = 102,
	KWD = 103,
	MZM = 104,
	SBD = 106,
	SIT = 107,
	SZL = 108,
	UGX = 109,
	VUV = 110,
	WST = 111,
	PYG = 112,
	UYU = 113,
	BOB = 114,
	BYR = 115,
	DataError = -99
}
export enum eDepartment {
	Not_Set = 0,
	Personal_Appearance = 13,
	Music_Country = 14,
	Music_London = 16,
	Music_for_Visual_Media = 19,
	Motion_Pictures = 20,
	Talent = 25,
	Theater = 30,
	Literary = 40,
	Television_Scripted = 50,
	Commercials = 53,
	Newscasters = 54,
	Corporate_Consulting = 59,
	Administration = 60,
	Business_Affairs = 61,
	Finance = 62,
	Information_Technology = 63,
	Human_Resources = 64,
	Telecommunications = 70,
	Floaters = 71,
	Mailroom = 72,
	Maintenance = 73,
	Special_Services = 80,
	Operations = 81,
	Automotive = 82,
	Miami_Operations = 83,
	Sports = 175,
	Games = 179,
	Digital_Media = 181,
	Communications = 200,
	Global = 201,
	Production = 202,
	Global_Insights_Group = 203,
	Other_Miscellaneous = 205,
	Voiceover = 250,
	Television_Unscripted = 251,
	Marketing = 252,
	Lectures = 253,
	Strategic_Consulting = 254,
	Corporate = 255,
	Story = 333,
	Literary_Packaging = 440,
	WMELive = 500,
	WME_IMG_Speakers = 501,
	WME_IMG_Sports = 502,
	IMG_Sports_Marketing = 503,
	Personal_AppearanceAssociate_NAV = 1300,
	Motion_PictureSupport_NAV = 2000,
	TalentAssociate_NAV = 2500,
	TheaterAssociate_NAV = 3000,
	LiteraryAssociate_NAV = 4000,
	TelevisionAssociate_NAV = 5000,
	TelevisionSupport_NAV = 5001,
	CommercialsAssociate_NAV = 5300,
	SportsAssociate_NAV = 17500,
	Digital_MediaAssociate_NAV = 18100,
	GlobalAssociate_NAV = 20100,
	GlobalPartner_NAV = 20101,
	ProductionSupport_NAV = 20200,
	ProductionAssociate_NAV = 20201,
	VoiceoverSupport_NAV = 25000,
	Alt_TVAssociate_NAV = 25100,
	Corporate_ConsultingAssociate_NAV = 25400,
	DataError = -99
}
export enum eDepartmentCategory {
	Not_Set = 0,
	ACTORS_MP = 102,
	ACTORS_TV = 103,
	TV_GUEST_HOST = 104,
	TV_SERIES_HOST = 105,
	ON_CAMERA_OVERSCALE = 111,
	ON_CAMERA_SCALE = 112,
	VO_RADIO_SCALE = 113,
	ANIMATION_SCALE = 114,
	INFOMERCIALS = 115,
	VIDEO_AUDIO = 116,
	ANIMATION_OVERSCALE = 117,
	VO_RADIO_OVERSCALE = 118,
	DIRECTORS = 121,
	WRITERS = 122,
	PRODUCERS = 123,
	OVERALL_DEAL = 124,
	PACKAGE = 126,
	PROFITS = 127,
	CONSULTING = 128,
	DIGITAL_MEDIA = 129,
	PA_ADULT_CONTEMPORARY = 131,
	PA_CHRISTIAN = 132,
	PA_CLUBS = 133,
	PA_COMEDY = 134,
	PA_CONTEMPORARY = 135,
	PA_COUNTRY = 136,
	PA_ELECTRONIC = 137,
	PA_FAIRS_AND_FESTIVALS = 138,
	PA_INTERNATIONAL = 139,
	PA_LATIN = 140,
	PA_LECTURES = 141,
	PA_LONDON = 142,
	PA_PRIVATE = 143,
	PA_THEATRICAL_TOURING = 144,
	PA_TOUR_MARKETING = 145,
	PA_URBAN = 146,
	APPEARANCE_FEE = 147,
	LIT_BOOKS_DOMESTIC = 151,
	LIT_BOOKS_FOREIGN = 152,
	LIT_LONDON = 153,
	LIT_MAGAZINES_DOMESTIC = 154,
	LIT_MAGAZINES_FOREIGN = 155,
	LIT_MISCELLANEOUS = 156,
	NEWSCASTERS = 161,
	IP_FEES = 162,
	IP_LICENSINGRETAINERS = 163,
	INDEPENDENT_SALES = 164,
	GAMECONSULTING = 166,
	GAMEDESIGNERS = 167,
	GAMELICENSING = 168,
	ART_DIRECTORS = 171,
	COSTUME_DESIGNERS = 172,
	DIRECTORS_OF_PHOTOGRAPHY = 173,
	EDITORS = 174,
	DESIGNERS = 175,
	VISUAL_EFFECTS_SUPERVISORS = 176,
	LINE_PRODUCER = 177,
	STUNT = 178,
	_2ND_UNIT_DIRECTOR = 179,
	THEATRE_DOMESTIC_PRODUCTIONS = 181,
	THEATRE_FOREIGN = 182,
	THEATRE_MISCELLANEOUS = 183,
	THEATRE_MUSIC_PUBLISHING = 184,
	THEATRE_ORIGINAL_CAST_ALBUM = 185,
	THEATRE_STOCK_AND_AMATEUR = 186,
	THEATRE_DIRECTORSCHOREOGRAPHERS = 187,
	THEATRE_ACTORS = 188,
	SPORTSPRODUCERS = 191,
	SPORTSTALENT = 192,
	PA_CROSSOVER = 194,
	PA_SELF_SERVE = 195,
	PA_SOUNDTRACKS = 196,
	PA_TOUR_SPONSORSHIP = 198,
	MISCELLANEOUS = 199,
	PKG_NTWRK_12_HR = 302,
	PKG_NTWRK_1_HR = 303,
	PKG_BASIC_CABLE_12_HR = 304,
	PKG_BASIC_CABLE_1_HR = 305,
	PKG_PAY_CABLE_12_HR = 306,
	PKG_PAY_CABLE_1_HR = 307,
	PKG_1ST_RUN_SYND = 308,
	PKG_MOW_AND_SPECIALS = 309,
	PKG_BE_DOM_SYND_AND_CABLE_SALES = 321,
	PKG_BE_FOR_SYND_AND_CABLE_SALES = 322,
	PKG_BE_DOM_DVD_AND_HV = 323,
	PKG_BE_FOR_DVD_AND_HV = 324,
	PKG_BE_DOM_MERCH_AND_OTHER_ANCILLARY = 325,
	PKG_BE_FOR_MERCH_AND_OTHER_ANCILLARY = 326,
	PKG_DEFERRED_COMMISSONS = 327,
	PROFITS_CLIENT = 331,
	PROFITS__BOX_OFFICE_BONUSES = 332,
	PROFITS_DOM_SYND_AND_CABLE_SALES = 333,
	PROFITS_FOR_SYND_AND_CABLE_SALES = 334,
	PROFITS_DOM_DVD_AND_HV = 335,
	PROFITS_FOR_DVD_AND_HV = 336,
	PROFITS_DOM_MERCH_AND_OTHER_ANCILLARY = 337,
	PROFITS_FOR_MERCH_AND_OTHER_ANCILLARY = 338,
	MRKTNG_SOLUTIONS_RETAINER_FEES = 351,
	MRKTNG_SOLUTIONS_PROJECT_FEES = 352,
	MRKTNG_SOLUTIONS_OTHER_FEES = 353,
	MRKTNG_SOLUTIONS_INTERNAL_BILLBACKS = 354,
	CLIENT_MRKTNG_RETAINER_FEES = 361,
	CLIENT_MRKTNG_PROJECT_FEES = 362,
	CLIENT_MRKTNG_OTHER_FEES = 363,
	CLIENT_MRKTNG_INTERNAL_BILLBACKS = 364,
	MIAMI_INCOME = 371,
	VO_TV_SCALE = 376,
	VO_TV_OVERSCALE = 377,
	PA_ASIA_PAC = 400,
	IMG_EGAMERS = 900,
	IMG_FIGURE_SKATING = 901,
	IMG_BROADCASTING = 902,
	IMG_COACHES = 903,
	IMG_TALENT_MARKETING = 904,
	IMG_ACTION_SPORTS = 905,
	OPTIONPURCHASE_TV = 950,
	OPTIONPURCHASE_MP = 951,
	OPTIONPURCHASE_OTHER = 952,
	DataError = -99
}
export enum eEthnicity {
	Not_Set = 0,
	Any = 1,
	Australian = 2,
	BlackAfricanAmerican = 3,
	Middle_Eastern = 4,
	Asian = 5,
	Caucasian = 6,
	East_Indian = 7,
	Filipino = 8,
	LatinoHispanic = 9,
	American_IndianAlaskan = 10,
	Puerto_Rican = 11,
	English = 12,
	European = 13,
	Eastern_European = 14,
	French = 15,
	Indian = 16,
	Diverse = 17,
	Pacific_Islander = 19,
	DataError = -99
}
export enum eGender {
	Not_Set = 0,
	Male = 1,
	Female = 2,
	Other = 3,
	DataError = -99
}
export enum eGridArea {
	Not_Set = 0,
	Client = 1,
	User = 2,
	PersonalAppearanceDeal = 3,
	PersonalAppearanceBooking = 4,
	MarketWatch = 5,
	TvPackagePreCrm = 6,
	TvPackageBooking = 7,
	TvPackagePackage = 8,
	Buyer = 9,
	Tv10Booking = 10,
	Contact = 11,
	DataError = -99
}
export enum eGridType {
	Not_Set = 0,
	SytemDefault = 1,
	System = 2,
	Personal = 3
}
export enum eLogEventType {
	Not_Set = 0,
	Insert = 1,
	Update = 2,
	Delete = 3,
	Activate = 4,
	Deactivate = 5,
	DataError = -99
}
export enum eNationality {
	Not_Set = 0,
	Afghan = 1,
	Aland_Islander = 2,
	Albanian = 3,
	Algerian = 4,
	American_Samoan = 5,
	Andorran = 6,
	Angolan = 7,
	Anguillan = 8,
	Antarctican = 9,
	Antiguan_and_Barbudan = 10,
	Argentine = 11,
	Armenian = 12,
	Aruban = 13,
	Australian = 14,
	Austrian = 15,
	Azerbaijani = 16,
	Bahamian = 17,
	Bahraini = 18,
	Bangladeshi = 19,
	Barbadian = 20,
	Belarusian = 21,
	Belgian = 22,
	Belizean = 23,
	Beninese = 24,
	Bermudian = 25,
	Bhutanese = 26,
	Bolivian = 27,
	Bonairean_Sint_Eustatius_and_Saba = 28,
	Bosnian_and_Herzegovinan = 29,
	Botswanan = 30,
	Bouvet_Islander = 31,
	Brazilian = 32,
	British_Indian_Ocean_Territory = 33,
	Bruneian_Darussalam = 34,
	Bulgarian = 35,
	Burkinabe_Faso = 36,
	Burundian = 37,
	Cambodian = 38,
	Cameroonian = 39,
	Canadian = 40,
	Cape_Verdian = 41,
	Cayman_Islander = 42,
	Central_African = 43,
	Chadian = 44,
	Chilean = 45,
	Chinese = 46,
	Christmas_Islander = 47,
	Cocos_Keeling_Islander = 48,
	Colombian = 49,
	Comorian = 50,
	Congolese = 51,
	Congolese_Democratic_Republic_of_the = 52,
	Cook_Islander = 53,
	Costa_Rican = 54,
	Cote_dIvoirean = 55,
	Croatian = 56,
	Cuban = 57,
	Curacaoan = 58,
	Cypriot = 59,
	Czech = 60,
	Dane = 61,
	Djiboutian = 62,
	Dominican = 63,
	Dominicanean = 64,
	Ecuadorean = 65,
	Egyptian = 66,
	El_Salvadorian = 67,
	Equatoguinean = 68,
	Eritrean = 69,
	Estonian = 70,
	Ethiopian = 71,
	Falkland_Islander_Malviner = 72,
	Faroe_Islander = 73,
	Fijian = 74,
	Finnish = 75,
	French_citizen = 76,
	French_Guiana_citizen = 77,
	French_Polynesia_citizen = 78,
	French_Southern_Territories_citizen = 79,
	Gabonese = 80,
	Gambian = 81,
	Georgian = 82,
	German = 83,
	Ghanaian = 84,
	Gibraltarian = 85,
	Greek = 86,
	Greenlander = 87,
	Grenadian = 88,
	Guadeloupien = 89,
	Guaman = 90,
	Guatemalan = 91,
	Guernseyan = 92,
	Guineaan = 93,
	GuineaBissau_national = 94,
	Guyanese = 95,
	Haitien = 96,
	Heard_Islander_and_Mcdonald_Islander = 97,
	Holy_See_citizen_Vatican_City_State = 98,
	Honduran = 99,
	Hong_Kong_citizen = 100,
	Hungarian = 101,
	Icelander = 102,
	Indian = 103,
	Indonesian = 104,
	Iranian_Islamic_Republic_of = 105,
	Iraqi = 106,
	Irish = 107,
	Israeli = 108,
	Italian = 109,
	Jamaican = 110,
	Japanese = 111,
	Jerseian = 112,
	Jordanian = 113,
	Kazakh = 114,
	Kenyan = 115,
	Kiribati = 116,
	Korean_Democratic_Peoples_Republic_of = 117,
	Korean_Republic_of = 118,
	Kuwaiti = 119,
	Kyrgyz = 120,
	Laotian = 121,
	Latvian = 122,
	Lebanese = 123,
	Lesothian = 124,
	Liberian = 125,
	Libyan = 126,
	Liechtensteiner = 127,
	Lithuanian = 128,
	Luxembourger = 129,
	Macao = 130,
	Macedonian = 131,
	Madagascaran = 132,
	Malawian = 133,
	Malaysian = 134,
	Maldivian = 135,
	Malian = 136,
	Maltese = 137,
	Marshallese = 138,
	Martiniquean = 139,
	Mauritanian = 140,
	Mauritian = 141,
	Mayottean = 142,
	Mexican = 143,
	Micronesian = 144,
	Moldovan = 145,
	Monegasque = 146,
	Mongolian = 147,
	Montenegrin = 148,
	Montserrat = 149,
	Moroccan = 150,
	Mozambican = 151,
	Myanmar = 152,
	Namibian = 153,
	Nauran = 154,
	Nepalese = 155,
	Netherlander = 156,
	New_Caledonian = 157,
	New_Zealander = 158,
	Nicaraguan = 159,
	Nigerien = 160,
	Nigerian = 161,
	Niuean = 162,
	Norfolk_Islander = 163,
	Northern_Mariana_Islander = 164,
	Norwegian = 165,
	Omani = 166,
	Pakistani = 167,
	Palauan = 168,
	Palestinean = 169,
	Panamian = 170,
	Papua_New_Guinean = 171,
	Paraguayan = 172,
	Peruvian = 173,
	Philippine = 174,
	Pitcairnan = 175,
	Polish = 176,
	Portuguase = 177,
	Puerto_Ricoan = 178,
	Qatari = 179,
	Reunionai = 180,
	Romanian = 181,
	Russian = 182,
	Rwandan = 183,
	Saint_Barthelemian = 184,
	Saint_Helen = 185,
	Saint_Kitts_and_Nevi = 186,
	Saint_Lucian = 187,
	Saint_Martin = 188,
	Saint_Pierre_and_Miquelon = 189,
	Saint_Vincent_and_the_Grenadines = 190,
	Samoan = 191,
	San_Marinese = 192,
	Sao_Tomean = 193,
	Saudi = 194,
	Senegalese = 195,
	Serbian = 196,
	Seychelloi = 197,
	Sierra_Leonean = 198,
	Singaporean = 199,
	Sint_Maartenan = 200,
	Slovak = 201,
	Slovenian = 202,
	Solomon_Islander = 203,
	Somali = 204,
	South_African = 205,
	South_Georgian_and_the_South_Sandwich_Islander = 206,
	South_Sudanese = 207,
	Spainish = 208,
	Sri_Lankan = 209,
	Sudanese = 210,
	Surinamese = 211,
	Svalbard_and_Jan_Mayen = 212,
	Swazilander = 213,
	Swedish = 214,
	Swiss = 215,
	Syrian = 216,
	Taiwanese = 217,
	Tajik = 218,
	Tanzanian = 219,
	Thai = 220,
	TimorLestean = 221,
	Togolese = 222,
	Tokelauan = 223,
	Tongan = 224,
	Trinidad_and_Tobagonian = 225,
	Tunisian = 226,
	Turkish = 227,
	Turkmen = 228,
	Turks_and_Caicos_Islander = 229,
	Tuvaluan = 230,
	Ugandan = 231,
	Ukrainian = 232,
	United_Arab_Emirates = 233,
	United_Kingdom_of_Great_Britain_and_Northern_Ireland = 234,
	United_States_of_America = 235,
	United_States_Minor_Outlying_Islands = 236,
	Uruguayan = 237,
	Uzbek = 238,
	Vanuatuan = 239,
	Venezuelan = 240,
	Vietnamese = 241,
	Virgin_Islander_British = 242,
	Virgin_Islander_US = 243,
	Wallis_and_Futunan = 244,
	Western_Saharan = 245,
	Yemeni = 246,
	Zambian = 247,
	Zimbabwean = 248,
	DataError = -99
}
export enum eOffice {
	Not_Set = 0,
	Beverly_Hills = 1,
	New_York = 2,
	Nashville = 3,
	London = 4,
	Miami = 6,
	Dallas = 8,
	IMG = 9,
	Sydney = 10,
	Hong_Kong = 12,
	DataError = -99
}
export enum ePaymentMethod {
	Not_Set = 0,
	Cash = 1,
	Check = 2,
	Wire = 3,
	ACH = 4,
	DataError = -99
}
export enum eRadiusUnit {
	Not_Set = 0,
	Miles = 1,
	Kilometers = 2,
	DataError = -99
}
export enum eRegion {
	Not_Set = 0,
	Worldwide = 1,
	North_America = 2,
	Europe = 3,
	Asia = 4,
	Australia = 5,
	USA = 6,
	South_America = 7,
	DataError = -99
}
export enum eReportType {
	Not_Set = 0,
	TVNonScripted_WMEPkg_List = 1,
	TVNonScripted_OpenStaffNeeds_List = 2,
	TVScriptedLogLine = 3,
	DevSoldGridByNetworkReport = 4,
	DevSoldGridByGenreReport = 5,
	TVScriptedISL = 6,
	CommProjectReport = 7,
	MoPicDirectorsByGenre = 8,
	MoPicWord = 9,
	MoPicWritersByGenre = 10,
	FestivalSummary = 11,
	ForeignClientListV3 = 12,
	ClientsWhoSingV3 = 13,
	ComedyTalent = 14,
	ClientsNonLABased = 15,
	ClientsByEthnicity = 16,
	TalentAgeListV3 = 17,
	Availabilities = 18,
	TheatreProjectReport = 19,
	MpWorkBook = 20,
	MoPicWorkbook = 21,
	TVNonScripted_NetworkDevelopment_List = 22,
	TVScriptedISL_ByNetwork = 23,
	AfricanAmericanClientsV2 = 24,
	TalentCompletedAvailsAssistance = 25,
	Visa_Sponsor_Status_ = 26,
	TVWorkbookV2 = 27,
	DealMemoV2 = 28,
	ContractV2 = 29,
	FinalTotalsV2 = 30,
	MusicAdminV2 = 31,
	BKSPAChangeMemoV2 = 32,
	BKSPAMissingFinalNumbersV2 = 33,
	BKSPAFinalBusinessV2 = 34,
	CONClientCreditsV2 = 35,
	AVBEventsV2 = 36,
	BKSPAOffersOfTheDayV2 = 37,
	ConfirmedNotIssuedV2 = 38,
	ActiveClientsExportV2 = 39,
	PAItineraryDetailV2 = 40,
	PAItineraryPdfV2 = 41,
	ClientsByDeptV2 = 42,
	ClientsByAlphaV2 = 43,
	MPWorkbookV2 = 44,
	TicketCountSumV2 = 45,
	TicketCountV2 = 46,
	ConfirmationLetter = 47,
	BKSPADelinquentDepositsSSRS = 48,
	PARouteSheetSSRS = 49,
	BKSPAProdContractSSRS = 50,
	BKSPADelinquentContractsSSRS = 51,
	BKSPAFiscalProfileSSRS2016 = 52,
	CONAgencyAgreementsV2 = 53,
	BKSPAFiscalProfileSummarySSRS2016 = 54,
	PAToursByMarketV2 = 55,
	TVNSWorkbookV2 = 56,
	PAItinActivityV2 = 57,
	PRJGridTVLitV2 = 58,
	PRJGridTVSummaryV2 = 59,
	BksDetailGetV2 = 60,
	BKSPAMusicTrackingV2 = 61,
	BKSCOSessionV2 = 62,
	BKSContractV2 = 63,
	MUSFiscalProfileSummaryV2 = 64,
	SubmissionHistoryV2 = 65,
	MPPitchV2 = 66,
	PitchReportV2 = 67,
	SubmissionsDetailV2 = 68,
	PitchListV2 = 69,
	BKSPaymentV2 = 70,
	PITTargetBuyerV2 = 71,
	ItineraryExport1MonthXlsx = 72,
	ItineraryExport3MonthXlsx = 73,
	ItineraryExport6MonthXlsx = 74,
	DataError = -99
}
export enum eStateProvince {
	Not_Set = 0,
	Alaska = 3,
	Alabama = 4,
	Alberta = 5,
	Arkansas = 8,
	Arizona = 14,
	British_Columbia = 18,
	California = 26,
	Colorado = 32,
	Connecticut = 36,
	Washington_DC = 40,
	Delaware = 41,
	Florida = 51,
	Georgia = 53,
	Hawaii = 58,
	Iowa = 63,
	Idaho = 65,
	Illinois = 67,
	Indiana = 68,
	Kansas = 79,
	Kentucky = 80,
	Louisiana = 81,
	Massachusetts = 86,
	Manitoba = 88,
	Maryland = 89,
	Maine = 90,
	Michigan = 92,
	Minnesota = 93,
	Missouri = 94,
	Mississippi = 97,
	Montana = 98,
	New_Brunswick = 99,
	North_Carolina = 100,
	North_Dakota = 101,
	Nebraska = 102,
	Newfoundland = 104,
	New_Hampshire = 106,
	New_Jersey = 108,
	New_Mexico = 109,
	Nova_Scotia = 111,
	Nevada = 112,
	New_York = 113,
	Ohio = 115,
	Oklahoma = 116,
	Ontario = 117,
	Oregon = 118,
	Pennsylvania = 119,
	Prince_Edward_Island = 122,
	Quebec = 128,
	Rhode_Island = 129,
	Saskatchewan = 136,
	South_Carolina = 137,
	South_Dakota = 140,
	Tennessee = 152,
	Texas = 156,
	Utah = 163,
	Virginia = 164,
	Vermont = 169,
	Washington = 170,
	Wisconsin = 173,
	West_Virginia = 175,
	Wyoming = 176,
	Northwest_Territories = 178,
	Nunavut = 179,
	Yukon = 180,
	DataError = -99
}
export enum eTimeZone {
	Not_Set = 0,
	Dateline_Standard_Time = 1,
	Samoa_Standard_Time = 2,
	UTC11 = 3,
	Hawaiian_Standard_Time = 4,
	Alaskan_Standard_Time = 5,
	Pacific_Standard_Time = 6,
	Pacific_Standard_Time_Mexico = 7,
	Mountain_Standard_Time = 8,
	Mountain_Standard_Time_Mexico = 9,
	US_Mountain_Standard_Time = 10,
	Canada_Central_Standard_Time = 11,
	Central_Standard_Time_Mexico = 12,
	Central_Standard_Time = 13,
	Central_America_Standard_Time = 14,
	US_Eastern_Standard_Time = 15,
	Eastern_Standard_Time = 16,
	SA_Pacific_Standard_Time = 17,
	Venezuela_Standard_Time = 18,
	Pacific_SA_Standard_Time = 19,
	SA_Western_Standard_Time = 20,
	Central_Brazilian_Standard_Time = 21,
	Atlantic_Standard_Time = 22,
	Paraguay_Standard_Time = 23,
	Newfoundland_Standard_Time = 24,
	Montevideo_Standard_Time = 25,
	Greenland_Standard_Time = 26,
	SA_Eastern_Standard_Time = 27,
	Argentina_Standard_Time = 28,
	E_South_America_Standard_Time = 29,
	MidAtlantic_Standard_Time = 30,
	UTC02 = 31,
	Cape_Verde_Standard_Time = 32,
	Azores_Standard_Time = 33,
	Morocco_Standard_Time = 34,
	UTC = 35,
	GMT_Standard_Time = 36,
	Greenwich_Standard_Time = 37,
	W_Europe_Standard_Time = 38,
	Central_Europe_Standard_Time = 39,
	Romance_Standard_Time = 40,
	Central_European_Standard_Time = 41,
	W_Central_Africa_Standard_Time = 42,
	Namibia_Standard_Time = 43,
	Jordan_Standard_Time = 44,
	GTB_Standard_Time = 45,
	Middle_East_Standard_Time = 46,
	Egypt_Standard_Time = 47,
	Syria_Standard_Time = 48,
	South_Africa_Standard_Time = 49,
	FLE_Standard_Time = 50,
	Israel_Standard_Time = 51,
	E_Europe_Standard_Time = 52,
	Arabic_Standard_Time = 53,
	Arab_Standard_Time = 54,
	Russian_Standard_Time = 55,
	E_Africa_Standard_Time = 56,
	Iran_Standard_Time = 57,
	Arabian_Standard_Time = 58,
	Azerbaijan_Standard_Time = 59,
	Mauritius_Standard_Time = 60,
	Georgian_Standard_Time = 61,
	Caucasus_Standard_Time = 62,
	Afghanistan_Standard_Time = 63,
	Ekaterinburg_Standard_Time = 64,
	Pakistan_Standard_Time = 65,
	West_Asia_Standard_Time = 66,
	India_Standard_Time = 67,
	Sri_Lanka_Standard_Time = 68,
	Nepal_Standard_Time = 69,
	Central_Asia_Standard_Time = 70,
	Bangladesh_Standard_Time = 71,
	N_Central_Asia_Standard_Time = 72,
	Myanmar_Standard_Time = 73,
	SE_Asia_Standard_Time = 74,
	North_Asia_Standard_Time = 75,
	China_Standard_Time = 76,
	North_Asia_East_Standard_Time = 77,
	Singapore_Standard_Time = 78,
	W_Australia_Standard_Time = 79,
	Taipei_Standard_Time = 80,
	Ulaanbaatar_Standard_Time = 81,
	Tokyo_Standard_Time = 82,
	Korea_Standard_Time = 83,
	Yakutsk_Standard_Time = 84,
	Cen_Australia_Standard_Time = 85,
	AUS_Central_Standard_Time = 86,
	E_Australia_Standard_Time = 87,
	AUS_Eastern_Standard_Time = 88,
	West_Pacific_Standard_Time = 89,
	Tasmania_Standard_Time = 90,
	Vladivostok_Standard_Time = 91,
	Magadan_Standard_Time = 92,
	Central_Pacific_Standard_Time = 93,
	New_Zealand_Standard_Time = 94,
	UTC12 = 95,
	Fiji_Standard_Time = 96,
	Kamchatka_Standard_Time = 97,
	Tonga_Standard_Time = 98,
	DataError = -99
}
export enum eContactTitle {
	Not_Set = 0,
	Mr = 1,
	Miss = 2,
	Mrs = 3,
	Ms = 4,
	Dr = 5,
	Prof = 6,
	Rev = 7,
	Sir = 8,
	Rabbi = 9,
	DataError = -99
}
export enum eDealArea {
	Not_Set = 0,
	Commercial = 1,
	Literary = 2,
	Motion_Picture = 3,
	Television = 4,
	Television_Package = 5,
	Television_Syndication = 6,
	Theatre = 7,
	Personal_Appearance_Performance = 8,
	Personal_Appearance_Production = 9,
	Service = 12,
	General = 13,
	Intellectual_Property = 16,
	Video_Games = 17,
	Marketing = 18,
	Digital = 19,
	Self_Serve = 20,
	General_London = 22,
	Research = 23,
	Production_Commercials = 24,
	Production_Television = 25,
	Production_Motion_Pictures = 26,
	IMG_Sports_Marketing = 27,
	Book_Option = 28,
	DataError = -99
}
export enum eDealAttachmentType {
	Not_Set = 0,
	Offer = 801,
	Other = 802,
	Contract_as_issued = 803,
	Contract_as_received_from_Buyer = 804,
	Contract_as_sent_to_Artist = 805,
	Fullyexecuted_Contract_as_sent_to_Buyer = 806,
	Buyerissued_Contract_as_Received = 807,
	Letter_Agreement = 808,
	Email = 809
}
export enum eDealBookingNoteType {
	Not_Set = 0,
	Accounting = 1,
	Business_Affairs = 2,
	Deal_Memo = 3,
	Tour_Compensation = 4,
	Special_Provisions = 5,
	Rehearsal = 6,
	Ground_Transportation = 7,
	Air_Freight_and_Excess_Baggage = 8,
	Air_Transportation = 9,
	Accommodations = 10,
	Lecture = 11,
	TESTING = 12,
	Venue_Avails = 13,
	Itinerary = 14,
	Visas_and_Work_Permits = 15,
	Production_AND_Catering = 16,
	Other_Trans_AND_Accommodations = 17,
	CCHybrid = 18,
	Administration = 19,
	Bank_Wire_Info = 21,
	Private_Note = 23,
	Future_use = 24,
	Outside_Agent_Split = 25,
	Additional_Notes = 26,
	Advertiser_Info = 27,
	Contract_Details = 28,
	Addendum_1 = 29,
	Addendum_2 = 30,
	Addendum_3 = 31,
	Addendum_4 = 32,
	Addendum_5 = 33,
	Addendum_6 = 34,
	Addendum_7 = 35,
	Addendum_8 = 36,
	Addendum_9 = 37,
	Addendum_10 = 38,
	Sub_Agent_Info = 39,
	CoAuthorCollaborator_Info = 40,
	Amount_Delinquent = 41,
	Delinquent_Since = 42,
	Amount_to_Remit = 43,
	Final_Due_Date = 44,
	Letter_Agreement_Terms_AND_Conditions = 45,
	Artist_Release_Amount = 46,
	Buyer_Release_Amount = 47,
	Deposits_Held_Amount = 48,
	Meals_and_Incidentals = 49,
	Role = 50,
	Length_of_Engagement = 51,
	Close_Date = 52,
	Billing = 53,
	Total_Guaranteed_Compensation = 54,
	Contigent_deferement = 55,
	Other_Remuneration = 56,
	Transportation_and_Expenses = 57,
	Remuneration_Collected_By = 58,
	Where_Deal_Emanated = 59,
	CONSIDERATION_Total_Price = 60,
	CONSIDERATION_Method_of_Payment = 61,
	CONSIDERATION_Option_if_any = 62,
	General_London_Note_ = 63,
	Start_Date = 64,
	Where_Rendered = 65,
	Type_Of_Services = 66,
	Lotus_Notes_Import_Values = 67,
	Recording_Broadcast_Social_Media = 68,
	DataError = -99
}
export enum eDealBookingType {
	Not_Set = 0,
	Concert = 1,
	Tour = 2,
	Festival = 3,
	DataError = -99
}
export enum eDealCompensationType {
	Not_Set = 0,
	Flat_Guarantee = 1,
	Bonus_Deal = 2,
	Promoter_Profit_Plus = 3,
	Versus_of_Net = 4,
	Versus_of_Gross = 5,
	Custom_Split = 6,
	Custom_Walkout_Plus = 7,
	Custom_Walkout_Versus = 8,
	Custom_Backend = 9,
	DataError = -99
}
export enum eDealContactType {
	Not_Set = 0,
	Client = 1,
	Buyer = 3,
	Other = 4,
	Sub_Agent = 6,
	Outside_Agent = 7,
	Agent = 8,
	Accounting = 9,
	Business_Affairs = 10,
	Group_Notification = 11,
	Payee2 = 12,
	Client_Associate = 13,
	Buyer_Associate = 14,
	Sub_Agent_Associate = 15,
	Outside_Agent_Associate = 16,
	Associate = 17,
	Payee = 18,
	Advertiser = 19,
	Contact = 20,
	Venue = 21,
	Signatory = 22,
	Production = 23,
	Contract_Administrator = 24,
	Ticket_Count = 25,
	Show = 26,
	Signatory_2 = 27,
	Production_Company = 28,
	Care_of = 29,
	Responsible_Agent = 30,
	Buyer_Contact = 32,
	Marketing_Contact = 33,
	Contract_Agent = 34,
	Invoice_Contact = 35,
	Buyer_Accounting = 36,
	Event_Coordinator = 37,
	Editor = 38,
	Coordinator = 39,
	Buying_On_Behalf_Of = 40,
	DataError = -99
}
export enum eDealContractTrackingType {
	Not_Set = 0,
	Offer_accepted = 22,
	Contract_received_from_publisher = 23,
	Contract_with_Business_Affairs = 24,
	Contract_to_client_for_signature = 25,
	Signed_contract_to_publisher = 26,
	Contract_to_publisher_for_signature = 27,
	Contract_with_Agent = 28,
	Signed_contract_to_buyer = 33,
	Contract_to_buyer_for_signature = 34,
	In_to_Contract_Dept = 36,
	Out_to_booking_agent = 37,
	Letter_Agreement_sent_to_buyer = 38,
	Letter_Agreement_received_from_buyer = 39,
	Contract_sent_to_buyer_unsigned = 40,
	Contract_received_from_buyer = 41,
	Contract_reviewed = 42,
	Contract_sent_to_artist = 43,
	Contract_received_from_artist = 44,
	Contract_sent_to_buyer_fully_executed = 45,
	Contract_received_by_Business_Affairs = 46,
	Contract_sent_to_responsible_agent_by_Business_Affairs = 47,
	Start_paperwork_to_client = 48,
	Start_paperwork_to_buyer = 49,
	Certificate_of_Authorship_to_business_affairs_attorney = 50,
	Certificate_of_Authorship_to_client = 51,
	Certificate_of_Authorship_to_buyer = 52,
	DataError = -99
}
export enum eDealCorrespondenceNoteType {
	Not_Set = 0,
	User_Note = 1,
	DataError = -99
}
export enum eDealCrossCollateralizedLevel {
	Not_Set = 0,
	None = 0,
	Tour = 1,
	Hybrid = 2,
	DataError = -99
}
export enum eDealCurrencyExchangeTerm {
	Not_Set = 0,
	Contract_Date = 1,
	Day_of_Show = 2,
	Negotiated = 3,
	DataError = -99
}
export enum eDealFestivalRating {
	Not_Set = 0,
	A = 1,
	B = 2,
	C = 3,
	DataError = -99
}
export enum eDealFestivalType {
	Not_Set = 0,
	Music_Festival = 1,
	Fair_Carnival = 2,
	Concert_Series = 3,
	Festival_Series = 4,
	Music_Conference = 5,
	Radio_Festival = 7,
	Lifestyle_Festival = 8,
	Street_Festival = 9,
	Benefit = 14,
	College_Festival = 16,
	Film_Festival = 17,
	Comedy_Festival = 18,
	Music_Cruise = 19,
	Christian = 20,
	College = 21,
	Corporate_Private = 22,
	DataError = -99
}
export enum eDealFinalTotalAuditStatus {
	Not_Set = 0,
	Entered = 1,
	Signed_Off_by_BA = 2,
	Signed_Off_by_RA = 3,
	Settled = 4,
	Modified = 5,
	DataError = -99
}
export enum eDealMerchRateType {
	Not_Set = 0,
	Venue_Sells_CD = 1,
	Artist_Sells_CD = 3,
	Venue_Sells_DVD = 4,
	Artist_Sells_DVD = 5,
	TBD = 6,
	Flat = 7,
	All_Merchandise = 8,
	CDDVD = 9,
	TShirtsSoft = 10,
	Other = 11,
	DataError = -99
}
export enum eDealMerchRateWhoSells {
	Not_Set = 0,
	Venue = 1,
	Artist = 2,
	TBD = 3,
	Venue_or_Artist = 4,
	DataError = -99
}
export enum eDealPaymentMethod {
	Not_Set = 0,
	Cash = 1,
	Check = 2,
	Bank_Deposit = 3,
	Wire = 4,
	DataError = -99
}
export enum eDealPaymentStatus {
	Not_Set = 0,
	Draft = 1,
	Posted = 2,
	Paid = 3,
	Cancelled = 4,
	DataError = -99
}
export enum eDealPaymentType {
	Not_Set = 0,
	Deposit = 1,
	Reimbursement = 2,
	Cash_Advance = 3,
	Bonus = 4,
	Settlement = 5,
	Balance_of_Show = 7,
	DataError = -99
}
export enum eDealPosition {
	Not_Set = 0,
	Agent = 1,
	Director = 2,
	Position = 3,
	DataError = -99
}
export enum eDealSetting {
	Not_Set = 0,
	Display_BreakevenSellout_Box_on_Deal_Memo = 1,
	Display_Support_Compensation_in_Show_Schedule_on_Deal_Memo_AND_Contract = 2,
	DataError = -99
}
export enum eDealShowScheduleType {
	Not_Set = 0,
	Support_TBA = 1,
	Support_Confirmed = 2,
	LoadIn = 3,
	Sound_Check = 4,
	Curfew = 5,
	Other = 6,
	Doors = 7,
	VIP_Meet_AND_Greet = 8,
	Second_Set = 9,
	Support_Pending = 10,
	Headliner = 11,
	CoHeadliner = 12,
	Intermission = 13,
	Show_Time = 14,
	DataError = -99
}
export enum eDealStatus {
	Not_Set = 0,
	Cancelled = 3,
	Pending = 6,
	Confirmed = 7,
	Rejected = 8,
	Withdrawn = 9,
	DataError = -99
}
export enum eDealTicketFeeType {
	Not_Set = 0,
	Facility = 1,
	Parking = 2,
	Taxes = 3,
	Misc_Surcharge = 4,
	Charity = 5,
	Ticket_Agency = 6,
	Local_City_Sales_Tax = 7,
	State_Sales_Tax = 8,
	Federal_Sales_Tax = 9,
	VAT = 10,
	GST = 11,
	Venue_Tax = 12,
	DataError = -99
}
export enum eDealTicketType {
	Not_Set = 0,
	GA_Standing = 1,
	GA_Seated = 2,
	Lawn = 3,
	VIPGold_Circle = 4,
	Other = 5,
	Unknown = 6,
	Reserved = 7,
	Auction = 8,
	Fan_Club = 9,
	VIP_Seated = 10,
	VIP_Standing = 11,
	Lower_Level = 12,
	Upper_Level = 13,
	Orchestra = 14,
	Mezzanine = 15,
	Balcony = 16,
	Loge = 17,
	Pit = 18,
	DataError = -99
}
export enum eDealType {
	Not_Set = 0,
	Public = 1,
	Private = 2,
	DataError = -99
}
export enum eDealBuyerAssociate {
	Not_Set = 0,
	Buyer_Contact = 1,
	Care_of = 2,
	Contract_Administrator = 3,
	Marketing_Contact = 4,
	Production = 5,
	Signatory = 6,
	Signatory_2 = 7,
	Ticket_Count = 8,
	DataError = -99
}
export enum eItineraryHoldType {
	Not_Set = 0,
	Not_Available = 0,
	Hold_1 = 1,
	Hold_2 = 2,
	Hold_3 = 3,
	Hold_4 = 4,
	Hold_5 = 5,
	Hold_6 = 6,
	Hold_7 = 7,
	Hold_8 = 8,
	DataError = -99
}
export enum eItinerarySettlementStatus {
	Not_Set = 0,
	Litigation = 1,
	Billed = 2,
	Settled = 3,
	Final_Totals_Requested = 4,
	Unsettled = 5,
	Agent_Followupv = 6,
	Held_per_Agent = 7,
	Held_per_Accounting = 9,
	DataError = -99
}
export enum eItineraryType {
	Not_Set = 0,
	General_Comment = 1,
	Public_Appearance = 2,
	Off = 3,
	Tentative = 4,
	Hold = 5,
	Confirmed = 6,
	Confirmed_Private = 7,
	Pending = 8,
	Pending_Private = 9,
	Note_to_Self = 10,
	Cancelled = 11,
	Rejected = 12,
	Withdrawn = 13,
	Holiday = 14,
	Block = 16,
	Fill = 17,
	Annotation_Note = 18,
	Annotation_Target = 19,
	DataError = -99
}
export enum eLeadAreaOfInterest {
	Not_Set = 0,
	Other = 1,
	DataError = -99
}
export enum eLeadSource {
	Not_Set = 0,
	ClientHUB_Roster = 1,
	ClientHUB_Client = 2,
	Manual = 3,
	DataError = -99
}
export enum eLeadStatus {
	Not_Set = 0,
	Open = 1,
	Closed = 2,
	DataError = -99
}
export enum eTv10PercentAttachmentType {
	Not_Set = 0,
	Offer = 601,
	Other = 602,
	Contract_as_issued = 603,
	Contract_as_received_from_Buyer = 604,
	Contract_as_sent_to_Artist = 605,
	Fullyexecuted_Contract_as_sent_to_Buyer = 606,
	Buyerissued_Contract_as_Received = 607,
	Letter_Agreement = 608,
	Email = 609
}
export enum eTv10PercentBookingCategory {
	Not_Set = 0,
	Development = 1,
	Overall = 2,
	Staffing = 3,
	DataError = -99
}
export enum eTv10PercentBookingNoteType {
	Not_Set = 0,
	Accounting = 1,
	Business_Affairs = 2,
	Deal_Memo = 3,
	Tour_Compensation = 4,
	Special_Provisions = 5,
	Rehearsal = 6,
	Ground_Transportation = 7,
	Air_Freight_and_Excess_Baggage = 8,
	Air_Transportation = 9,
	Accommodations = 10,
	Lecture = 11,
	TESTING = 12,
	Venue_Avails = 13,
	Itinerary = 14,
	Visas_and_Work_Permits = 15,
	Production_AND_Catering = 16,
	Other_Trans_AND_Accommodations = 17,
	CCHybrid = 18,
	Administration = 19,
	Bank_Wire_Info = 21,
	Private_Note = 23,
	Future_use = 24,
	Outside_Agent_Split = 25,
	Additional_Notes = 26,
	Advertiser_Info = 27,
	Contract_Details = 28,
	Addendum_1 = 29,
	Addendum_2 = 30,
	Addendum_3 = 31,
	Addendum_4 = 32,
	Addendum_5 = 33,
	Addendum_6 = 34,
	Addendum_7 = 35,
	Addendum_8 = 36,
	Addendum_9 = 37,
	Addendum_10 = 38,
	Sub_Agent_Info = 39,
	CoAuthorCollaborator_Info = 40,
	Amount_Delinquent = 41,
	Delinquent_Since = 42,
	Amount_to_Remit = 43,
	Final_Due_Date = 44,
	Letter_Agreement_Terms_AND_Conditions = 45,
	Artist_Release_Amount = 46,
	Buyer_Release_Amount = 47,
	Deposits_Held_Amount = 48,
	Meals_and_Incidentals = 49,
	Role = 50,
	Length_of_Engagement = 51,
	Close_Date = 52,
	Billing = 53,
	Total_Guaranteed_Compensation = 54,
	Contigent_deferement = 55,
	Other_Remuneration = 56,
	Transportation_and_Expenses = 57,
	Remuneration_Collected_By = 58,
	Where_Deal_Emanated = 59,
	CONSIDERATION_Total_Price = 60,
	CONSIDERATION_Method_of_Payment = 61,
	CONSIDERATION_Option_if_any = 62,
	General_London_Note_ = 63,
	Start_Date = 64,
	Where_Rendered = 65,
	Type_Of_Services = 66,
	Lotus_Notes_Import_Values = 67,
	Recording_Broadcast_Social_Media = 68,
	DataError = -99
}
export enum eTv10PercentBookingStatus {
	Not_Set = 0,
	Draft = 1,
	Pending = 2,
	Awaiting = 3,
	Open = 4,
	Confirmed = 5,
	Approved = 6,
	Reject = 7,
	Cancelled = 8,
	Closed = 9,
	DataError = -99
}
export enum eTv10PercentBookingType {
	Not_Set = 0,
	Writer = 1,
	Producer = 2,
	Director = 3,
	DataError = -99
}
export enum eTv10PercentFormat {
	Not_Set = 0,
	Stock_Amateur_Rights = 1,
	Animation = 2,
	MiniSeries = 3,
	Other = 4,
	PilotMOW = 5,
	PilotSpecial = 6,
	Series_Cable = 7,
	Series_Network = 8,
	Special = 9,
	TV_Movie = 10,
	DataError = -99
}
export enum eTv10PercentLength {
	Not_Set = 0,
	Drama = 1,
	Comedy_Single_Camera = 2,
	Comedy_Multi_Camera = 3,
	Alternative = 4,
	Animation = 5,
	MiniSeries = 6,
	MOW = 7,
	DataError = -99
}
export enum eTv10PercentLevel {
	Not_Set = 0,
	EP = 1,
	CoEP = 2,
	ConsP = 3,
	SP = 4,
	P = 5,
	CoP = 6,
	ESE = 7,
	SE = 8,
	SW = 9,
	DataError = -99
}
export enum eTv10PercentPaymentMethod {
	Not_Set = 0,
	Cash = 1,
	Check = 2,
	Bank_Deposit = 3,
	Wire = 4,
	DataError = -99
}
export enum eTv10PercentPaymentStatus {
	Not_Set = 0,
	Draft = 1,
	Posted = 2,
	Paid = 3,
	Cancelled = 4,
	DataError = -99
}
export enum eTv10PercentPaymentType {
	Not_Set = 0,
	Receipt = 1,
	Guaranteed = 2,
	Overage = 3,
	Ancillary = 4,
	Option = 5,
	Memo = 6,
	Royality = 7,
	Advance = 8,
	Bonus = 9,
	DistFee = 11,
	Flat_Fee = 12,
	Other = 13,
	DataError = -99
}
export enum eTv10PercentPosition {
	Not_Set = 0,
	Agent = 1,
	Director = 2,
	Position = 3,
	DataError = -99
}
export enum eTvPckgAgency {
	Not_Set = 0,
	_3_Arts_Entertainment = 1,
	Adelstein = 2,
	Brillstein = 3,
	ChengCaplan = 4,
	Curtis_Brown = 5,
	Dixon_Talent = 6,
	DSA = 7,
	Felker = 8,
	Gendler_AND_Kelly = 9,
	HofflandPolone = 10,
	Innovative_Artists = 11,
	Kapital = 12,
	Oasis = 13,
	RWSG_Agency = 14,
	Shuman = 15,
	United_Agents = 16,
	Unrepresented = 17,
	WME_Client_not_in_Connect = 18,
	CAA = 30,
	UTA = 31,
	ICM = 32,
	Paradigm = 33,
	Gersh = 34,
	_40_Original_Artists = 35,
	Abrams = 36,
	APA = 37,
	Hotchkiss_AND_Associates = 38,
	IPG = 39,
	KaplanStahler = 40,
	Rebel_Entertainment_Partners = 41,
	Rothman_Brecher_Kim = 42,
	Walerstein = 43,
	Verver = 44,
	Vision_Arts = 45,
	WME = 46,
	Vital_Artists = 47,
	DataError = -99
}
export enum eTvPckgBeStatus {
	Not_Set = 0,
	None = 1,
	UnsureUnlikely = 2,
	Expected = 3,
	Active = 4,
	Extinguished = 5,
	DataError = -99
}
export enum eTvPckgBookingStatus {
	Not_Set = 0,
	Completed = 1,
	In_Production = 2,
	PreProduction = 3,
	Ordered = 4,
	Projected = 5,
	DataError = -99
}
export enum eTvPckgBeOwner {
	Not_Set = 0,
	WME = 1,
	Endeavor = 2,
	WME_AND_Endeavor = 3,
	DataError = -99
}
export enum eTvPckgAddlBeOwner {
	Not_Set = 0,
	WME = 1,
	Endeavor = 2
}
export enum eTvPckgOutletType {
	Not_Set = 0,
	_1st_Run = 1,
	Broadcast = 2,
	Basic_Cable = 3,
	Premium_Cable = 4,
	Streaming = 5,
	International = 6,
	DataError = -99
}
export enum eTvPckgElementStatus {
	Not_Set = 0,
	Active = 1,
	Passive = 2,
	Dropped_Out = 3,
	DataError = -99
}
export enum eTvPckgElementWorkType {
	Not_Set = 0,
	Creator = 1,
	Showrunner = 2,
	EP = 3,
	Writer = 4,
	CoWriter = 5,
	Director = 6,
	NWEP_nonwriting_executive_producer = 7,
	Talent = 8,
	Production_Company = 9,
	Rights_Format = 10,
	DataError = -99
}
export enum eTvPckgGenre {
	Not_Set = 0,
	Animation_1 = 1,
	Celebrity_2 = 2,
	Competition_2 = 3,
	Anthology_1 = 4,
	Movie_1 = 5,
	Game_Show_2 = 6,
	Limited_1 = 7,
	Multicam_Comedy_1 = 8,
	Procedural_1 = 9,
	Reality_2 = 10,
	Serialized_Drama_1 = 11,
	Singlecam_Comedy_1 = 12,
	Specials_2 = 13,
	Talk_Show_2 = 14,
	Travel_2 = 15,
	Documentary_2 = 16,
	Animation_3 = 17,
	Celebrity_3 = 18,
	Competition_3 = 19,
	Anthology_3 = 20,
	Movie_3 = 21,
	Game_Show_3 = 22,
	Limited_3 = 23,
	Multicam_Comedy_3 = 24,
	Procedural_3 = 25,
	Reality_3 = 26,
	Serialized_Drama_3 = 27,
	Singlecam_Comedy_3 = 28,
	Specials_3 = 29,
	Talk_Show_3 = 30,
	Travel_3 = 31,
	Documentary_3 = 32,
	Special_1 = 33,
	DataError_99 = -99
}
export enum eTvPckgGenreTVScripted {
	Not_Set = 0,
	Animation = 1,
	Anthology = 4,
	Movie = 5,
	Limited = 7,
	Multicam_Comedy = 8,
	Procedural = 9,
	Serialized_Drama = 11,
	Singlecam_Comedy = 12,
	Special = 33,
	DataError = -99
}
export enum eTvPckgGenreTVNonScripted {
	Not_Set = 0,
	Celebrity = 2,
	Competition = 3,
	Game_Show = 6,
	Reality = 10,
	Specials = 13,
	Talk_Show = 14,
	Travel = 15,
	Documentary = 16,
	DataError = -99
}
export enum eTvPckgGenreDigital {
	Not_Set = 0,
	Animation = 17,
	Celebrity = 18,
	Competition = 19,
	Anthology = 20,
	Movie = 21,
	Game_Show = 22,
	Limited = 23,
	Multicam_Comedy = 24,
	Procedural = 25,
	Reality = 26,
	Serialized_Drama = 27,
	Singlecam_Comedy = 28,
	Specials = 29,
	Talk_Show = 30,
	Travel = 31,
	Documentary = 32,
	DataError = -99
}
export enum eTvPckgLength {
	Not_Set = 0,
	Other = 1,
	_30 = 2,
	_60 = 3,
	DataError = -99
}
export enum eTvPckgNoteType {
	Not_Set = 0,
	Email = 1,
	Package_Letter = 2,
	Contract = 3,
	Other = 4,
	Note = 5,
	Package_Letter_Redline = 6,
	DataError = -99
}
export enum eTvPckgNoteSender {
	Not_Set = 0,
	WME = 1,
	Other = 2
}
export enum eTvPckgPaymentStatus {
	Not_Set = 0,
	Pending = 1,
	Confirmed = 2,
	Receipt_Posted = 3,
	Cancelled = 4,
	Closed = 5,
	Withdrawn = 6,
	Rejected = 7,
	DataError = -99
}
export enum eTvPckgPackageStatus {
	Not_Set = 0,
	New = 1,
	Request_Made = 2,
	Debate = 3,
	Confirmed = 4,
	No_PackageDenied = 5,
	Stepped_Out = 6,
	Confirming_Split = 7,
	Confirmed_Negotiating_Fees = 8,
	DataError = -99
}
export enum eTvPckgProjectStatus {
	Not_Set = 0,
	PilotPresentation_Order = 1,
	CanceledCompleted = 2,
	Series_Ordered = 3,
	Development = 4,
	OnAir = 5,
	Dead = 6,
	Shopping = 7,
	DataError = -99
}
export enum eTvPckgDepartment {
	Not_Set = 0,
	TV_Scripted = 1,
	TV_NonScripted = 2,
	Digital = 3,
	DataError = -99
}
export enum eTvPckgShareType {
	Not_Set = 0,
	Full = 1,
	_23 = 2,
	_60 = 3,
	_12 = 4,
	_40 = 6,
	_13 = 7,
	_14 = 8,
	Other = 9,
	OUT = 10,
	_34 = 11,
	DataError = -99
}
export enum eTvPckgSplitStatus {
	Not_Set = 0,
	Open = 1,
	Closed = 2,
	NA = 3,
	DataError = -99
}
export enum eTvPckgTvBooking {
	Not_Set = 0,
	_20052006 = 1,
	_20062007 = 2,
	_20072008 = 3,
	_20082009 = 4,
	_20092010 = 5,
	_20102011 = 6,
	_20112012 = 7,
	_20122013 = 8,
	_20132014 = 9,
	_20142015 = 10,
	_20152016 = 11,
	_20162017 = 12,
	_20172018 = 13,
	_20182019 = 14,
	_20192020 = 15,
	_20202021 = 16,
	_20212022 = 17,
	_20222023 = 18,
	_20232024 = 19,
	_20242025 = 20,
	_20252026 = 21,
	_20262027 = 22,
	_20272028 = 23,
	_20282029 = 24,
	_20292030 = 25,
	DataError = -99
}
export enum eTvPckgPosition {
	Not_Set = 0,
	Controlling = 1,
	Subordinate = 2,
	Independent = 3,
	DataError = -99
}
export enum eTvPckgNavServiceType {
	Not_Set = 0,
	Directors_TV_Scripted = 1,
	Directors_TV_NonScripted = 2,
	Miscellaneous_TV_Scripted = 3,
	Miscellaneous_TV_NonScripted = 4,
	Overall_Deal_TV_Scripted = 5,
	Overall_Deal_TV_NonScripted = 6,
	Package_TV_Scripted = 7,
	Package_TV_NonScripted = 8,
	Package_BE_Dom_DVD_HV_TV_Scripted = 9,
	Package_BE_Dom_DVD_HV_TV_NonScripted = 10,
	Package_BE_Dom_Merch_Oth_TV_Scripted = 11,
	Package_BE_Dom_Merch_Oth_TV_NonScripted = 12,
	Package_BE_For_Merch_Oth_TV_NonScripted = 13,
	Package_BE_Intl_DVD_HV_TV_Scripted = 14,
	Package_BE_Intl_DVD_HV_TV_NonScripted = 15,
	Package_BE_Intl_Merch_Oth_TV_Scripted = 16,
	Package_BE_Intl_Synd_Cbl_TV_Scripted = 17,
	Package_BE_Intl_Synd_Cbl_TV_NonScripted = 18,
	Package_1st_Run_Syndication_TV_Scripted = 19,
	Package_1st_Run_Syndication_TV_NonScripted = 20,
	Package_Backend_TV_Scripted = 21,
	Package_Backend_TV_NonScripted = 22,
	Package_Basic_Cable_Half_Hour_TV_Scripted = 23,
	Package_Basic_Cable_Half_Hour_TV_NonScripted = 24,
	Package_Basic_Cable_Hour_TV_Scripted = 25,
	Package_Basic_Cable_Hour_TV_NonScripted = 26,
	Package_Deferred_Commissions_TV_Scripted = 27,
	Package_Deferred_Commissions_TV_NonScripted = 28,
	Package_MOW_Specials_TV_Scripted = 29,
	Package_MOW_Specials_TV_NonScripted = 30,
	Package_Network_Half_Hour_TV_Scripted = 31,
	Package_Network_Half_Hour_TV_NonScripted = 32,
	Package_Network_Hour_TV_Scripted = 33,
	Package_Network_Hour_TV_NonScripted = 34,
	Package_Pay_Cable_Half_Hour_TV_Scripted = 35,
	Package_Pay_Cable_Half_Hour_TV_NonScripted = 36,
	Package_Pay_Cable_Hour_TV_Scripted = 37,
	Package_Pay_Cable_Hour_TV_NonScripted = 38,
	Package_Premium_Digital_Backend_TV_Scripted = 39,
	Package_Premium_Digital_Backend_TV_NonScripted = 40,
	Package_Premium_Digital_Upfront_TV_Scripted = 41,
	Package_Premium_Digital_Upfront_TV_NonScripted = 42,
	Premium_Digital_Backend_TV_Scripted = 43,
	Premium_Digital_Commission_TV_Scripted = 44,
	Premium_Digital_Commission_TV_NonScripted = 45,
	Premium_Digital_Profit_Participation_TV_Scripted = 46,
	Premium_Digital_Profit_Participatn_TV_NonScripted = 47,
	Premium_Digital_Upfront_TV_Scripted = 48,
	Producers_TV_Scripted = 49,
	Producers_TV_NonScripted = 50,
	Profits_TV_Scripted = 51,
	Profits_TV_NonScripted = 52,
	Profits_BE_Dom_Merch_Oth_TV_Scripted = 53,
	Profits_BE_Dom_Merch_Oth_TV_NonScripted = 54,
	Profits_BE_Intl_Merch_Oth_TV_NonScripted = 55,
	Profits_BE_Intl_Merch_Oth_TV_Scripted = 56,
	Profits_Client_TV_Scripted = 57,
	Profits_Client_TV_NonScripted = 58,
	Profits_Dom_DVD_AND_HV_TV_Scripted = 59,
	Profits_Dom_DVD_AND_HV_TV_NonScripted = 60,
	Profits_Dom_Synd_AND_Cable_TV_Scripted = 61,
	Profits_Dom_Synd_AND_Cable_TV_NonScripted = 62,
	Profits_For_DVD_AND_HV_TV_Scripted = 63,
	Profits_For_DVD_AND_HV_TV_NonScripted = 64,
	Profits_For_Synd_AND_Cable_TV_Scripted = 65,
	Profits_For_Synd_AND_Cable_TV_NonScripted = 66,
	Talent_TV_NonScripted = 67,
	Writers_TV_Scripted = 68,
	Writers_TV_NonScripted = 69,
	Package_Premium_Digital_Backend_Digital = 70,
	Package_Premium_Digital_Upfront_Digital = 71,
	Package_Backend_Digital = 72,
	DataError = -99
}
export enum eTvPckgNavReloadState {
	Not_Set = 0,
	Ready_to_Reload = 1,
	Validation_Errors = 2,
	Failure = 3,
	Success = 4,
	DataError = -99
}
export enum eTvPckgBookingType {
	Not_Set = 0,
	Upfront = 1,
	Backend = 2,
	DataError = -99
}
export enum eTvPckgTmsBookingStatus {
	Pending = 1,
	Confirmed = 2,
	Cancelled = 3
}
export enum eVenueAttachmentType {
	Not_Set = 0,
	Offer = 401,
	Other = 402,
	Contract_as_issued = 403,
	Contract_as_received_from_Buyer = 404,
	Contract_as_sent_to_Artist = 405,
	Fullyexecuted_Contract_as_sent_to_Buyer = 406,
	Buyerissued_Contract_as_Received = 407,
	Letter_Agreement = 408,
	Email = 409,
	Client_Information_Form = 410,
	ACH_Form = 411,
	Fee_Authorizations = 412,
	Check_Authorization = 413,
	Check_Endorsement = 414,
	W4 = 416,
	W9 = 417,
	_590 = 418,
	I9 = 419,
	Passport = 420,
	Social_Security = 421,
	Drivers_License = 422,
	Birth_Certificate = 423,
	Other_Papers = 424,
	Photo = 426,
	Video = 427,
	Other_Speakers = 428,
	Headshot_Unapproved = 429,
	Movie_Clip = 430,
	Other_Asset = 431,
	Video_Gallery = 433,
	Document = 435,
	Headshot_Approved = 436,
	Credits = 437,
	Resume = 438,
	Bio = 439,
	Agency_Agreements = 440,
	Articles_of_Incorporation = 441,
	Confirmation_of_Rep_Letter = 442,
	Full_Bio = 443,
	BKS_TV_type_1 = 444,
	BKS_MP_type = 445,
	BKS_CO_type = 446,
	BKS_TV_type_2 = 447,
	Script_PDF = 448,
	Script = 449,
	Project_Role_Side = 450,
	W8 = 451,
	Visa_Document = 452,
	Client_Packet = 453,
	Contract = 454,
	Talent_Packet = 455,
	Minor_Packet = 456,
	Other_Documents = 457
}
export enum eVenueEmailType {
	Not_Set = 0,
	Personal = 1,
	Office = 2,
	DataError = -99
}
export enum eVenueNoteType {
	Not_Set = 0,
	Public_Comments = 1,
	Executive_Notes = 2,
	Literary_Rights = 3,
	DataError = -99
}
export enum eVenuePhoneType {
	Not_Set = 0,
	Home = 1,
	Mobile = 2,
	Office = 3,
	DataError = -99
}
export enum eVenueType {
	Not_Set = 0,
	Theater = 1,
	Amphitheater = 2,
	Casino = 3,
	Hall = 4,
	Stadium = 5,
	Fair = 6,
	Festival = 7,
	DataError = -99
}
export enum eContactStatus {
	Not_Set = 0,
	Client_ALL = 1,
	Client_LTD = 2,
	Hip_Pocket = 3,
	Deal_Only = 4,
	Former_Client = 5,
	Package_Show = 6,
	DataError = -99
}
export enum eTvPckgNavTransactionState {
	Not_Set = 0,
	Ready_to_Post = 1,
	Validation_Errors = 2,
	Failure = 3,
	Success = 4,
	DataError = -99
}
export enum eDealEventSubType {
	Not_Set = 0,
	Comedy = 1,
	Conference = 2,
	Corporate = 3,
	Cruise = 4,
	Fair = 5,
	Festival = 6,
	Gala_Fundraiser = 7,
	Podcast = 8,
	DataError = -99
}
export enum eDealEventType {
	Not_Set = 0,
	Concert = 1,
	Lecture = 2,
	DataError = -99
}
export enum eDealSubType {
	Not_Set = 0,
	Annual_Recurring = 1,
	Email_Blast = 2,
	Invite_Only = 3,
	Pre_or_Post_Press_Release = 4,
	Public_Website = 5,
	Social_Media = 6,
	Traditional_Media = 7,
	DataError = -99
}
export enum eDatabaseContactType {
	Client = 1,
	Buyer = 2,
	User = 3,
	Contact = 4,
	Venue = 5
}
export enum eSearchUserSubType {
	Coordinator = 1,
	Agent = 2,
	Assistant = 3,
	Trainee = 4,
	Other = 5
}
export enum eSearchContactSubType {
	Generic = 1,
	Talent = 2,
	Agent = 3,
	Industry = 4
}
export enum eSearchAgentSubType {
	SubAgent = 1,
	OutsideAgent = 2,
	CastingAgent = 3,
	UserAgent = 4,
	ContactAgent = 5
}
